import { Storage } from 'aws-amplify';
import axios from 'axios';
import { Fragment, useEffect, useState } from 'react';
import { CommonLoading } from 'react-loadingg';
import { useParams } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import DownloadIcon from '../../images/download-icon.svg';
// import PDFlogo from '../../images/pdf-logo.svg';
// import Playlogo from '../../images/play-icon.png';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';

import "./GrievanceForm.css"; 
import AttachmentUploader from './AttachmentUploader';
import ReassignModal from './ReassignModal';
// import FactoryDropdown from './FactoryDropdown';

const GrievanceForm = (props) => {
    const [isLoading, setIsLoading] = useState(true);
    const [grievances, setGrievances] = useState([]);
    const [notiToken, setNotiToken] = useState([]);
    
    const [isFHR, setFHR] = useState(false);
    const [isPIC, setPIC] = useState(false);
    const [isAdmin, setAdmin] = useState(false);
    
    const [updatename, setUpdatedByName] = useState([]);
    const [updateID, setUpdatedByID] = useState([]);
    const [updateTime, setUpdatedTime] = useState([]);
    const [updateEmail, setUpdatedEmail] = useState([]);
    const [validatename, setValidatedByName] = useState([]);
    const [validateID, setValidatedByID] = useState([]);
    const [validateTime, setValidatedTime] = useState([]);
    const [closename, setClosedName] = useState([]);
    const [closeID, setClosedByID] = useState([]);
    
    const [closedTime, setClosedTime] = useState([]);
    const [formid, setFormID] = useState([]);
    const [formid2, setFormID2] = useState([]);
    const [name, setName] = useState([]);
    const [userID, setBadgeID] = useState([]);
    const [email, setEmail] = useState([]);
    
    const [factory, setFactory] = useState([]);
    const [factoryList, setFactoryList] = useState([]);
    
    const [applicationdate, setApplicationDate] = useState([]);
    const [applicationdatev2, setApplicationDateV2] = useState([]);
    const [applicationtime, setApplicationTime] = useState([]);

    const [categoryID, setCategoryID] = useState([]);
    const [category, setCategory] = useState([]);
    const [subcategoryID, setSubCategoryID] = useState([]);
    const [subcategory, setSubCategory] = useState([]);
    const [issueID, setIssueID] = useState([]);
    const [issue, setIssue] = useState([]);
    const [hostelZoneName, sethostelZoneName] = useState([]);
    const [hostelUnit, sethostelUnit] = useState([]);

    const [issueText, setIssueText] = useState([]);
    const [voice, setVoice] = useState([]);
    const [playVoice, setVoiceUrl] = useState([]);
    const [remark, setRemark] = useState([]);
    
    const [image, setImage] = useState([]);
    // const [attachmentLink, setAttachmentLink] = useState([]);
    const [uploadImage, setUploadImage] = useState([]);
    const [originalImageName, setOriginalImageName] = useState([]);
    
    const [priority, setPriority] = useState([]);
    const [todayDate, setToday] = useState([]);
    const [actionRemark, setAction] = useState([]);
    const [validateRemark, setValidate] = useState([]);
    const [closeRemark, setClose] = useState([]);
    
    const [flowStatusFHRClosed] = useState('31');
    const [flowStatusCloseStaff] = useState('31');
    const [flowStatusPICWorker] = useState('2');
    const [flowStatus, setStatus] = useState([]);
    
    const [userType, setUserType] = useState([]);
    const [grievanceStatus, setCurrentStatus] = useState([]);
    const [currentStatusName, setCurrentStatusName] = useState([]);
    
    const [actionAttachment, setActionAttachment] = useState([]);
    const [validateAttachment, setValidateAttachment] = useState([]);
    const [actionRemarkList, setActionList] = useState([]);
    const [validateRemarkList, setValidateList] = useState([]);

    const [reassignModal, setReassignModal] = useState(false);
    const handleReassignModal = () => setReassignModal(!reassignModal);
    
    const currentUser = localStorage.getItem('username');
    const currentUserID = localStorage.getItem('badgeID');


    const { REACT_APP_API_BACKEND_URL } = process.env;

    const { id } = useParams();

    useEffect(() => {
        if (props.grievancePermission) {
          const grievancePermissionFromParent = props.grievancePermission;
          
          if (grievancePermissionFromParent == 0) {
                window.stop();
                alert('You have no permissions to access this page.');
                window.location = '/';
          }
          else {
                setIsLoading(false);
          }
        }
    
    }, [props.grievancePermission]);

    // useEffect(() => {
    //     const getGrievances = async () => {
    //         const grievanceFromServer = await fetchGrievances();
    //         const item = grievanceFromServer.find(
    //             (grievance) => grievance.grievanceID === id
    //         );
    //         setGrievances(item);
    //     };

    //     getGrievances();
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [id]);

    // const fetchGrievances = async () => {
    //     const res = await fetch(
    //         REACT_APP_API_BACKEND_URL + '/api/grievance/getgrievancelist'
    //     );
    //     const data = await res.json();
    //     if(data.roleID == 2){
    //         console.log("I am FHR");
    //         setFHR(true);
    //     }
    //     else{
    //         console.log("I am PIC");
    //         setPIC(true);
    //     }
    //     // Map id into the list to have unique key
    //     return data.GrievanceList;
    // };

    useEffect(() => {
        fetchGrievances();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [localStorage.getItem('badgeID')]);

    async function fetchGrievances() {
        if (localStorage.getItem('badgeID')) {
            const url =
            REACT_APP_API_BACKEND_URL + '/api/grievance/getgrievancelist';
        axios
            .post(url, { userID: localStorage.getItem('badgeID') })
            .then((response) => {
                if(response.data.roleID == 2){
                    // console.log("I am FHR");
                    setFHR(true);
                }
                else if(response.data.roleID == 1){
                    // console.log("I am PIC");
                    setPIC(true);
                }
                else if(response.data.roleID == 3){
                    // console.log("I am Admin");
                    setAdmin(true);
                }
                const grievanceFromServer = response.data.GrievanceList;
                const item = grievanceFromServer.find(
                (grievance) => grievance.grievanceID === id
                );
                setGrievances(item);
                
            })
            .catch((err) => console.error(err));
        }
    }

    useEffect(() => {
        const insertData = () => {
            setToday(
                moment().format('DD/MM/YYYY')
            );
            setFormID(grievances.grievanceID);
            setName(grievances.createdByName?.toLowerCase());
            setBadgeID(grievances.createdByID);
            setEmail(grievances.createdByEmail);
            setFactory(grievances.factory);
            setApplicationDate(
                moment(grievances.createdDate).format('DD/MM/YYYY')
            );
            setApplicationTime(
                moment(grievances.createdDate).format('HH:mm')
            );
            setApplicationDateV2(
                moment(grievances.createdDate).format('MMYYYY')
            );
            setCategoryID(grievances.categoryID);
            setCategory(grievances.categoryName);
            setSubCategoryID(grievances.subcategoryID);
            setSubCategory(grievances.subcategoryName);
            setIssueID(grievances.issueID);
            setIssue(grievances.issueName);
            sethostelZoneName(grievances.hostelZoneName);
            sethostelUnit(grievances.hostelUnit);
            setIssueText(grievances.issueText);
            setVoice(grievances.voice);
            setRemark(grievances.remark);
            setAction(grievances.actionRemark);
            setCurrentStatus(grievances.grievanceStatusID);
            setCurrentStatusName(grievances.grievanceStatusName);
            setValidate(grievances.validateRemark);
            setPriority(grievances.priorityName);
            setUpdatedByName(grievances.updatedByName?.toLowerCase());
            setUpdatedByID(grievances.updatedByID);
            setUpdatedTime(
                moment(grievances.updatedDate).format('DD/MM/YYYY')
            );
            setUpdatedEmail(grievances.updatedByEmail);
            // setUpdatedEmail("zl_tan@topglove.com.my");
            setValidatedByName(grievances.validatedByName?.toLowerCase());
            setValidatedByID(grievances.validatedByID);
            setValidatedTime(
                moment(grievances.validatedDate).format('DD/MM/YYYY')
            );
            setClosedName(grievances.closedByName?.toLowerCase());
            setClosedByID(grievances.closedByID);
            setClosedTime(
                moment(grievances.closedDate).format('DD/MM/YYYY')
            );
            setClose(grievances.closeRemark);
            setImage(grievances.attachement);
            setUserType(grievances.userType);
            setActionAttachment(grievances.actionAttachment);
            setValidateAttachment(grievances.validateAttachment);
            setFormID2("TGGRI_"+applicationdatev2+"_"+grievances.grievanceID);
        };

        insertData();
    }, [grievances, applicationdatev2]);

    useEffect(() => {
        fetchNotiToken();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userID]);

    async function fetchNotiToken() {
        if (userID?.length !== 0 && userID !== undefined) {
            const url =
            REACT_APP_API_BACKEND_URL + '/api/grievance/getnotitoken';
        axios
            .post(url, { userID: userID })
            .then((response) => {
                setNotiToken(response.data.UserDataList[0].token);
            })
            .catch((err) => console.error(err));
        }
    }

    useEffect(() => {
        fetchFactoryEmailAction();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [factory, formid]);

    async function fetchFactoryEmailAction() {
        if (factory?.length !== 0 && factory !== undefined) {
            const url =
            REACT_APP_API_BACKEND_URL + '/api/grievance/getfactoryemailaction';
        axios
            .post(url, { grievanceID: formid, factory: factory })
            .then((response) => {
                if(response.data.GrievanceValidateList.length != response.data.GrievanceActionList.length){
                    response.data.GrievanceActionList.pop();
                    if(response.data.GrievanceValidateList.length === 0)
                    response.data.GrievanceActionList = [];
                }
                // console.log(response.data.GrievanceActionList);
                // console.log(response.data.GrievanceValidateList);
                setFactoryList(response.data.GrievanceList);
                setActionList(response.data.GrievanceActionList);
                setValidateList(response.data.GrievanceValidateList);
                // setFactoryEmail(response.data.GrievanceList[0].email);
                // setFactoryEmailName(response.data.GrievanceList[0].emailName);
                // setFactoryEmail("zl_tan@topglove.com.my");
                // setFactoryEmailName("Tan Zi Le");
            })
            .catch((err) => console.error(err));
        }
    }

    function downloadBlob(blob, filename) {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename || 'download';
        const clickHandler = () => {
          setTimeout(() => {
            URL.revokeObjectURL(url);
            a.removeEventListener('click', clickHandler);
          }, 150);
        };
        a.addEventListener('click', clickHandler, false);
        a.click();
        return a;
    }
    
    // async function fetchAttachment() {
    //     if (image?.length > 0) {
    //         const imagelist = image.split(',');
    //         let attachmentList = [];
    //         for (let i = 0; i < imagelist.length; i++) {
    //             const attachmentURL = await Storage.get(imagelist[i]);
    //             attachmentList.push(attachmentURL);
    //         }
    //         setAttachmentLink(attachmentList);
    //     }
    // }

    // useEffect(() => {
    //     fetchAttachment();
    // }, [image]);

    async function downloadFile() {
        if(image){
            const imagelist = image.split(',');
            // console.log(imagelist);
            for (let i = 0; i < imagelist.length; i++) {
                let index = i+1;
                const fileUrl = await Storage.get(imagelist[i], { download: true })
                if(imagelist[i].includes("jpg")){
                    downloadBlob(fileUrl.Body, formid+'_Attachments_'+index+'.jpg');
                }
                else if(imagelist[i].includes("jpeg")){
                    downloadBlob(fileUrl.Body, formid+'_Attachments_'+index+'.jpeg');
                }
                else if(imagelist[i].includes("png")){
                    downloadBlob(fileUrl.Body, formid+'_Attachments_'+index+'.png');
                }
                else if(imagelist[i].includes("mp4")){
                    downloadBlob(fileUrl.Body, formid+'_Attachments_'+index+'.mp4');
                }
                else if(imagelist[i].includes("pdf")){
                    downloadBlob(fileUrl.Body, formid+'_Attachments_'+index+'.pdf');
                }
                else if(imagelist[i].includes("mov")){
                    downloadBlob(fileUrl.Body, formid+'_Attachments_'+index+'.mov');
                }
                else if(imagelist[i].includes("PDF")){
                    downloadBlob(fileUrl.Body, formid+'_Attachments_'+index+'.PDF');
                }
            }
        }
    }

    async function downloadactionAttachment() {
        if(actionAttachment){
            const actionattachmentlist = actionAttachment.split(',');
            // console.log(actionattachmentlist);
            for (let i = 0; i < actionattachmentlist.length; i++) {
                let index = i+1;
                const fileUrl = await Storage.get(actionattachmentlist[i], { download: true })
                if(actionattachmentlist[i].includes("jpg")){
                    downloadBlob(fileUrl.Body, formid+'_Action_'+index+'.jpg');
                }
                else if(actionattachmentlist[i].includes("jpeg")){
                    downloadBlob(fileUrl.Body, formid+'_Action_'+index+'.jpeg');
                }
                else if(actionattachmentlist[i].includes("png")){
                    downloadBlob(fileUrl.Body, formid+'_Action_'+index+'.png');
                }
                else if(actionattachmentlist[i].includes("mp4")){
                    downloadBlob(fileUrl.Body, formid+'_Action_'+index+'.mp4');
                }
                else if(actionattachmentlist[i].includes("pdf")){
                    downloadBlob(fileUrl.Body, formid+'_Action_'+index+'.pdf');
                }
                else if(actionattachmentlist[i].includes("mov")){
                    downloadBlob(fileUrl.Body, formid+'_Action_'+index+'.mov');
                }
                else if(actionattachmentlist[i].includes("PDF")){
                    downloadBlob(fileUrl.Body, formid+'_Action_'+index+'.PDF');
                }
            }
        }
    }

    async function downloadPastActionAttachment(pastActionAttachment, index) {
        if(pastActionAttachment){
            const actionattachmentlist = pastActionAttachment.split(',');
            // console.log(actionattachmentlist);
            for (let i = 0; i < actionattachmentlist.length; i++) {
                let rollingnumber = i+1;
                let trail_no = index+1;
                const fileUrl = await Storage.get(actionattachmentlist[i], { download: true })
                if(actionattachmentlist[i].includes("jpg")){
                    downloadBlob(fileUrl.Body, formid+'_ActionTrail'+trail_no+'_'+rollingnumber+'.jpg');
                }
                else if(actionattachmentlist[i].includes("jpeg")){
                    downloadBlob(fileUrl.Body, formid+'_ActionTrail'+trail_no+'_'+rollingnumber+'.jpeg');
                }
                else if(actionattachmentlist[i].includes("png")){
                    downloadBlob(fileUrl.Body, formid+'_ActionTrail'+trail_no+'_'+rollingnumber+'.png');
                }
                else if(actionattachmentlist[i].includes("mp4")){
                    downloadBlob(fileUrl.Body, formid+'_ActionTrail'+trail_no+'_'+rollingnumber+'.mp4');
                }
                else if(actionattachmentlist[i].includes("pdf")){
                    downloadBlob(fileUrl.Body, formid+'_ActionTrail'+trail_no+'_'+rollingnumber+'.pdf');
                }
                else if(actionattachmentlist[i].includes("mov")){
                    downloadBlob(fileUrl.Body, formid+'_ActionTrail'+trail_no+'_'+rollingnumber+'.mov');
                }
                else if(actionattachmentlist[i].includes("PDF")){
                    downloadBlob(fileUrl.Body, formid+'_ActionTrail'+trail_no+'_'+rollingnumber+'.PDF');
                }
            }
        }
    }

    async function downloadvalidateAttachment() {
        if(validateAttachment){
            const validateattachmentlist = validateAttachment.split(',');
            // console.log(actionattachmentlist);
            for (let i = 0; i < validateattachmentlist.length; i++) {
                let index = i+1;
                const fileUrl = await Storage.get(validateattachmentlist[i], { download: true })
                if(validateattachmentlist[i].includes("jpg")){
                    downloadBlob(fileUrl.Body, formid+'_Validation_'+index+'.jpg');
                }
                else if(validateattachmentlist[i].includes("jpeg")){
                    downloadBlob(fileUrl.Body, formid+'_Validation_'+index+'.jpeg');
                }
                else if(validateattachmentlist[i].includes("png")){
                    downloadBlob(fileUrl.Body, formid+'_Validation_'+index+'.png');
                }
                else if(validateattachmentlist[i].includes("mp4")){
                    downloadBlob(fileUrl.Body, formid+'_Validation_'+index+'.mp4');
                }
                else if(validateattachmentlist[i].includes("pdf")){
                    downloadBlob(fileUrl.Body, formid+'_Validation_'+index+'.pdf');
                }
                else if(validateattachmentlist[i].includes("mov")){
                    downloadBlob(fileUrl.Body, formid+'_Validation_'+index+'.mov');
                }
                else if(validateattachmentlist[i].includes("PDF")){
                    downloadBlob(fileUrl.Body, formid+'_Validation_'+index+'.PDF');
                }
            }
        }
    }

    async function downloadPastvalidateAttachment(pastValidateAttachment, index) {
        if(pastValidateAttachment){
            const validateattachmentlist = pastValidateAttachment.split(',');
            // console.log(actionattachmentlist);
            for (let i = 0; i < validateattachmentlist.length; i++) {
                let rollingnumber = i+1;
                let trail_no = index+1;
                const fileUrl = await Storage.get(validateattachmentlist[i], { download: true })
                if(validateattachmentlist[i].includes("jpg")){
                    downloadBlob(fileUrl.Body, formid+'_ValidationTrail'+trail_no+'_'+rollingnumber+'.jpg');
                }
                else if(validateattachmentlist[i].includes("jpeg")){
                    downloadBlob(fileUrl.Body, formid+'_ValidationTrail'+trail_no+'_'+rollingnumber+'.jpeg');
                }
                else if(validateattachmentlist[i].includes("png")){
                    downloadBlob(fileUrl.Body, formid+'_ValidationTrail'+trail_no+'_'+rollingnumber+'.png');
                }
                else if(validateattachmentlist[i].includes("mp4")){
                    downloadBlob(fileUrl.Body, formid+'_ValidationTrail'+trail_no+'_'+rollingnumber+'.mp4');
                }
                else if(validateattachmentlist[i].includes("pdf")){
                    downloadBlob(fileUrl.Body, formid+'_ValidationTrail'+trail_no+'_'+rollingnumber+'.pdf');
                }
                else if(validateattachmentlist[i].includes("mov")){
                    downloadBlob(fileUrl.Body, formid+'_ValidationTrail'+trail_no+'_'+rollingnumber+'.mov');
                }
                else if(validateattachmentlist[i].includes("PDF")){
                    downloadBlob(fileUrl.Body, formid+'_ValidationTrail'+trail_no+'_'+rollingnumber+'.PDF');
                }
            }
        }
    }

    async function fetchVoice() {
        if (voice) {
            const voiceUrl = await Storage.get(voice);
            setVoiceUrl(voiceUrl);
        }
    }

    useEffect(() => {
        fetchVoice();
        // console.log(playVoice);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [voice]);

    async function downloadVoice() {
        if(voice){
            const fileUrl = await Storage.get(voice, { download: true })
            downloadBlob(fileUrl.Body, formid+'_VoiceMessage.mp3');
        }
    }

    const history = useHistory();

    const getImageUrl = (uuidFileName, originalName) => {
        setUploadImage([...uuidFileName]);
        setOriginalImageName(originalName);
        // console.log(uploadImage);
    };

    const returntogtable = () => {
        history.push('/grievance');
    }

    const sendnoti = async (noti) => {
        const url =
            REACT_APP_API_BACKEND_URL + '/api/grievance/closenoti';
        const notiInfo = {
            formid: noti.formid,
            applicationdatev2: noti.applicationdatev2,
            notiToken: noti.notiToken,
        };
        axios
            .post(url, notiInfo)
            .then(
            )
            .catch((err) => console.error(err));
    };

    const sendVerificationEmail = async (email) => {
        const url =
            REACT_APP_API_BACKEND_URL + '/api/grievance/sendveriemail';
        const emailInfo = {
            email_receiver: email.factoryEmail,
            email_cc: email.factoryEmail,
            hr_name: email.factoryEmailName,
            pic_username: email.currentUser,
            document_id: email.formid2,
            grievance_type: email.category,
            user_name: email.name,
            user_badgeid: email.userID
        };
        axios
            .post(url, emailInfo)
            .then(
            )
            .catch((err) => console.error(err));
    };

    const sendRejectionEmail = async (email) => {
        const url =
            REACT_APP_API_BACKEND_URL + '/api/grievance/sendrejectemail';
        const emailInfo = {
            email_receiver: email.updateEmail,
            email_cc: email.updateEmail,
            pic_username: email.updatename,
            document_id: email.formid2,
            grievance_type: email.category,
            user_name: email.name,
            user_badgeid: email.userID
        };
        axios
            .post(url, emailInfo)
            .then(
            )
            .catch((err) => console.error(err));
    };

    const updateGrievanceStaff = async (grievance) => {
        const url =
            REACT_APP_API_BACKEND_URL + '/api/grievance/editgrievance';
        const grievanceDetails = {
            grievanceID: grievance.formid,
            remark: grievance.actionRemark,
            closeRemark: grievance.closeRemark,
            updatedBy: grievance.currentUserID,
            flowStatus: grievance.flowStatusCloseStaff,
            attachment: grievance.uploadimagelist
        };
        axios
            .post(url, grievanceDetails)
            .then(
                (response) => alert('Grievance status has been successfully updated!'),
                setTimeout(() => {
                    history.push('/grievance');
                    window.location.reload();
                }, 1000)
            )
            .catch((err) => console.error(err));
    };

    const updateGrievanceWorker = async (grievance) => {
        const url =
            REACT_APP_API_BACKEND_URL + '/api/grievance/editgrievance';
        const grievanceDetails = {
            grievanceID: grievance.formid,
            remark: grievance.actionRemark,
            closeRemark: grievance.closeRemark,
            updatedBy: grievance.currentUserID,
            flowStatus: grievance.flowStatusPICWorker,
            attachment: grievance.uploadimagelist
        };
        axios
            .post(url, grievanceDetails)
            .then(
                (response) => alert('Grievance status has been successfully updated!'),
                setTimeout(() => {
                    history.push('/grievance');
                    window.location.reload();
                }, 1000)
            )
            .catch((err) => console.error(err));
    };

    const validateGrievanceFHR = async (grievance) => {
        const url =
            REACT_APP_API_BACKEND_URL + '/api/grievance/editgrievance';
        const grievanceDetails = {
            grievanceID: grievance.formid,
            remark: grievance.validateRemark,
            closeRemark: grievance.closeRemark,
            updatedBy: grievance.currentUserID,
            flowStatus: grievance.flowStatus,
            attachment: grievance.uploadimagelist,
        };
        // console.log(grievanceDetails);
        axios
            .post(url, grievanceDetails)
            .then(
                (response) => alert('Grievance status has been successfully updated!'),
                setTimeout(() => {
                    history.push('/grievance');
                    window.location.reload();
                }, 1000)
            )
            .catch((err) => console.error(err));
    };

    const closeGrievanceFHR = async (grievance) => {
        const url =
            REACT_APP_API_BACKEND_URL + '/api/grievance/editgrievance';
        const grievanceDetails = {
            grievanceID: grievance.formid,
            remark: grievance.actionRemark,
            updatedBy: grievance.currentUserID,
            flowStatus: grievance.flowStatusFHRClosed,
            attachment: grievance.uploadimagelist
        };
        axios
            .post(url, grievanceDetails)
            .then(
                (response) => alert('Grievance status has been successfully updated!'),
                setTimeout(() => {
                    history.push('/grievance');
                    window.location.reload();
                }, 1000)
            )
            .catch((err) => console.error(err));
    };

    const onSubmitPIC = (e) => {
        e.preventDefault();
        if (actionRemark == "") {
            alert('Please enter an action');
        } else{
            if (userType == 1){
                if(!window.confirm('Do you want to submit this?')) {
                    return false;
                }
                fetchNotiToken();
                sendnoti({
                    formid,
                    applicationdatev2,
                    notiToken
                });
                const uploadimagelist = uploadImage.toString();
                updateGrievanceStaff({
                    formid,
                    actionRemark,
                    closeRemark,
                    currentUserID,
                    flowStatusCloseStaff,
                    uploadimagelist
                });
            }
            else{
                if(!window.confirm('Do you want to submit this?')) {
                    return false;
                }
                // console.log(factoryList);
                for (let i = 0; i < factoryList.length; i++) {
                    const factoryEmail = factoryList[i].email;
                    const factoryEmailName = factoryList[i].emailName;
                    sendVerificationEmail({
                        factoryEmail,
                        factoryEmail,
                        factoryEmailName,
                        currentUser,
                        formid2,
                        category,
                        name,
                        userID
                    });
                }
                const uploadimagelist = uploadImage.toString();
                updateGrievanceWorker({
                    formid,
                    actionRemark,
                    closeRemark,
                    currentUserID,
                    flowStatusPICWorker,
                    uploadimagelist
                });
            }
        }
    };

    const onSubmitFHR = (e) => {
        e.preventDefault();

        if(isFHR && grievanceStatus == 1){
            if (actionRemark == "") {
                alert('Please enter an action');
            } 
            else{
                // alert('FHR Worker Complete');
                if(!window.confirm('Do you want to submit this?')) {
                    return false;
                }
                fetchNotiToken();
                sendnoti({
                    formid,
                    applicationdatev2,
                    notiToken
                });
                const uploadimagelist = uploadImage.toString();
                closeGrievanceFHR({
                    formid,
                    actionRemark,
                    currentUserID,
                    flowStatusFHRClosed,
                    uploadimagelist
                });
            }
        }
        else{
            if (validateRemark == "") {
                alert('Please enter an action');
            } else if (flowStatus == "") {
                alert('Please select a status');
            } else{
                // alert('FHR Worker Validate');
                if(!window.confirm('Do you want to submit this?')) {
                    return false;
                }
                if(flowStatus == 3){
                    fetchNotiToken();
                    sendnoti({
                        formid,
                        applicationdatev2,
                        notiToken
                    });
                }
                if(flowStatus == 4){
                    sendRejectionEmail({
                        updateEmail,
                        updateEmail,
                        updatename,
                        formid2,
                        category,
                        name,
                        userID
                    });
                }
                const uploadimagelist = uploadImage.toString();
                validateGrievanceFHR({
                    formid,
                    validateRemark,
                    closeRemark,
                    currentUserID,
                    flowStatus,
                    uploadimagelist
                });
            }
        }
    };

    const onSubmitAdmin = (e) => {
        e.preventDefault();

        if(isAdmin && grievanceStatus == 1 || grievanceStatus == 5){
            if (actionRemark == "") {
                alert('Please enter an action');
            } 
            else{
                // alert('FHR Worker Complete');
                if(!window.confirm('Do you want to submit this?')) {
                    return false;
                }
                fetchNotiToken();
                sendnoti({
                    formid,
                    applicationdatev2,
                    notiToken
                });
                const uploadimagelist = uploadImage.toString();
                closeGrievanceFHR({
                    formid,
                    actionRemark,
                    currentUserID,
                    flowStatusFHRClosed,
                    uploadimagelist
                });
            }
        }
        else if (isAdmin && grievanceStatus == 4){
            if (actionRemark == "") {
                alert('Please enter an action');
            } 
            else{
                // alert('FHR Worker Complete');
                if(!window.confirm('Do you want to submit this?')) {
                    return false;
                }
                fetchNotiToken();
                sendnoti({
                    formid,
                    applicationdatev2,
                    notiToken
                });
                const uploadimagelist = uploadImage.toString();
                closeGrievanceFHR({
                    formid,
                    actionRemark,
                    currentUserID,
                    flowStatusFHRClosed,
                    uploadimagelist
                });
            }
        }
        else{
            if (validateRemark == "") {
                alert('Please enter an action');
            } else if (flowStatus == "") {
                alert('Please select a status');
            } else{
                // alert('FHR Worker Validate');
                if(!window.confirm('Do you want to submit this?')) {
                    return false;
                }
                if(flowStatus == 3){
                    fetchNotiToken();
                    sendnoti({
                        formid,
                        applicationdatev2,
                        notiToken
                    });
                }
                if(flowStatus == 4){
                    sendRejectionEmail({
                        updateEmail,
                        updateEmail,
                        updatename,
                        formid2,
                        category,
                        name,
                        userID
                    });
                }
                const uploadimagelist = uploadImage.toString();
                validateGrievanceFHR({
                    formid,
                    validateRemark,
                    closeRemark,
                    currentUserID,
                    flowStatus,
                    uploadimagelist
                });
            }
        }
    };

    const saveAction = async () => {
        if (actionRemark == "") {
            alert('Please enter an action');
        } 
        else{
            const uploadimagelist = uploadImage.toString();
            const url =
                REACT_APP_API_BACKEND_URL + '/api/grievance/editgrievance';
            const grievanceDetails = {
                grievanceID: formid,
                remark: actionRemark,
                closeRemark: closeRemark,
                updatedBy: currentUserID,
                flowStatus: 5,
                attachment: uploadimagelist
            };
            // console.log(grievanceDetails);
            axios
                .post(url, grievanceDetails)
                .then(
                    (response) => alert('Grievance draft has been successfully saved!'),
                    setTimeout(() => {
                        history.push('/grievance');
                        window.location.reload();
                    }, 1000)
                )
                .catch((err) => console.error(err));
        }
    };

    const saveValidate = async () => {
        if (validateRemark == "") {
            alert('Please enter an action');
        } 
        else{
            const uploadimagelist = uploadImage.toString();
            const url =
                REACT_APP_API_BACKEND_URL + '/api/grievance/editgrievance';
            const grievanceDetails = {
                grievanceID: formid,
                remark: validateRemark,
                closeRemark: closeRemark,
                updatedBy: currentUserID,
                flowStatus: 6,
                attachment: uploadimagelist
            };
            // console.log(grievanceDetails);
            axios
                .post(url, grievanceDetails)
                .then(
                    (response) => alert('Grievance draft has been successfully saved!'),
                    setTimeout(() => {
                        history.push('/grievance');
                        window.location.reload();
                    }, 1000)
                )
                .catch((err) => console.error(err));
        }
    };

    const reassignGrievance = (reassign) => {
        const url = REACT_APP_API_BACKEND_URL + '/api/grievance/reassigngrievance';
        const reassignDetails = {
            grievanceID: reassign.formid,
            factory: reassign.selectfactory,
            category: reassign.selectCategory,
            subCategory: reassign.selectSubCategory,
            issue: reassign.selectIssueCategory,
        };

        axios
            .post(url, reassignDetails)
            .then(
                (response) =>
                    alert('Grievance form has been successfully reassign!'),
                setTimeout(() => {
                    setReassignModal(!reassignModal);
                }, 500),
                setTimeout(() => {
                    window.location.reload();
                }, 1000)
            )
            .catch((err) => console.error(err));
    };


    return (
        <Fragment>
            {isLoading ? (
                <CommonLoading />
            ) : (
                <div className='main-hero-container'>
                    <div
                        className={`${
                            props.isActive ? 'container is-active' : 'container-fluid'
                        }`}
                    >   <div style={{ justifyContent: 'space-between', display: 'flex' }}>
                            <button className='btn-primary' onClick={returntogtable}>Back</button>
                            <button className='btn-primary' style={{ display: isAdmin  && grievanceStatus != 3 ? "block" : "none" }} onClick={handleReassignModal}>Reassign</button>
                            <ReassignModal
                                show={reassignModal}
                                handleClose={handleReassignModal}
                                formid={formid}
                                factory={factory}
                                categoryID={categoryID}
                                category={category}
                                subcategoryID={subcategoryID}
                                subcategory={subcategory}
                                issueID={issueID}
                                issue={issue}
                                onAdd={reassignGrievance}
                            />
                        </div>
                        <div className='jumbotron text-center'>
                            Grievance Application Form
                        </div>
                        <div className='freezepane'>
                            <div className='freezepanetitle'>
                                <span className='freezepanespacing'>Section A: Requested by (Applicant Information) </span>
                            </div>
                        </div>
                        <div className='row readgrievance'>
                            <div className='col-sm-3'>
                                <div className='sectionA'>Form ID: </div>
                                <div className='sectionA'>Name: </div>
                                <div className='sectionA'>Badge ID: </div>
                                <div className='sectionA'>Factory: </div>
                                {/* <div className='sectionA' style={{ display: isAdmin ? "block" : "none" }}>{selectfactory} </div> */}
                            </div>
                            <div className='col-sm-3'>
                                <div className='sectionAinput'><input type="text" className='formtextcolor' value={formid2} readOnly/></div>
                                <div className='sectionAinput'><input type="text" className='formtextname' value={name} readOnly/></div>
                                <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={userID} readOnly /></div>
                                <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={factory} readOnly /></div>
                                {/* <div className='sectionAinput' style={{ display: isAdmin ? "block" : "none" }}>
                                    <FactoryDropdown
                                    getFactory={getFactory} factory={factory}
                                    />
                                </div> */}
                            </div>
                            <div className='col-sm-3'>
                                <div className='sectionA'>Email: </div>
                                <div className='sectionA'>Application Date: </div>
                                <div className='sectionA'>Application Time: </div>
                            </div>
                            <div className='col-sm-3'>
                                <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={email} readOnly/></div>
                                <div className='sectionAinput'><input type="text" className='formtextcolor' value={applicationdate} readOnly/></div>
                                <div className='sectionAinput'><input type="text" className='formtextcolor' value={applicationtime} readOnly /></div>
                            </div>
                        </div>
                        <div className='freezepane'>
                            <div className='freezepanetitle'>
                                <span className='freezepanespacing'>Section B: Grievance Application Detail </span>
                            </div>
                        </div>
                        <div className='row readgrievance'>
                            <div className='col-sm-3'>
                                <div className='sectionA'>Grievance Category: </div>
                                {( hostelZoneName &&<div className='sectionA'>Hostel Zone: </div>)}
                                {( hostelUnit &&<div className='sectionA'>Hostel Unit: </div>)}
                                <div className='sectionA'>Grievance Sub Category: </div>
                                <div className='sectionA'>Type of Issue: </div>
                            </div>
                            <div className='col-sm-3'>
                                <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={category} readOnly/></div>
                                {( hostelZoneName &&<div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={hostelZoneName} readOnly/></div>)}
                                {( hostelUnit &&<div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={hostelUnit} readOnly/></div>)}
                                <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={subcategory} readOnly/></div>
                                <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={issue} readOnly/></div>
                            </div>
                            <div className='col-sm-6'>
                                <div style={{ display: image ? "block" : "none" }}>
                                    <div className='sectionAImage'>Attachments:</div>
                                    {/* <div className='imageDownloadLink'>{attachmentLink?.length} files uploaded (<span className='imageDownloadLink2' onClick={() => {downloadFile()}}>Download All</span>)</div> 
                                    {attachmentLink?.map(attachmentLink =>
                                        <span style={{marginLeft:'8px'}} key={attachmentLink}>
                                            {attachmentLink.includes("jpg") && <a href={attachmentLink} target="_blank"><img src={attachmentLink} style={{width: '70px', height:'70px', marginRight:'12px'}}/></a>}
                                            {attachmentLink.includes("jpeg") && <a href={attachmentLink} target="_blank"><img src={attachmentLink} style={{width: '70px', height:'70px', marginRight:'12px'}}/></a>}
                                            {attachmentLink.includes("png") && <a href={attachmentLink} target="_blank"><img src={attachmentLink} style={{width: '70px', height:'70px', marginRight:'12px'}}/></a>}
                                            {attachmentLink.includes("mp4") && <a href={attachmentLink} target="_blank"><img src={Playlogo} style={{width: '70px', height:'70px', marginRight:'12px'}}/></a>}
                                            {attachmentLink.includes("mov") && <a href={attachmentLink} target="_blank"><img src={Playlogo} style={{width: '70px', height:'70px', marginRight:'12px'}}/></a>}
                                            {attachmentLink.includes("pdf") && <a href={attachmentLink} target="_blank"><img src={PDFlogo} style={{width: '70px', height:'70px', marginRight:'12px'}}/></a>}
                                            {attachmentLink.includes("PDF") && <a href={attachmentLink} target="_blank"><img src={PDFlogo} style={{width: '70px', height:'70px', marginRight:'12px'}}/></a>}
                                        </span>
                                        )
                                    } */}
                                    <img 
                                        src={DownloadIcon} 
                                        className='table-icon'
                                        style={{maxWidth: '90px'}} 
                                        onClick={() => {downloadFile()}} 
                                        alt=''
                                    />
                                </div>
                            </div>
                            <div className='col-sm-3'>
                                <div className='sectionARemarks' style={{ display: issueText ? "block" : "none" }}>Issue Details: </div>
                                <div className='sectionARemarks' style={{ display: remark ? "block" : "none" }}>Remarks: </div>
                            </div>
                            <div className='col-sm-9'>
                                <div className='sectionAinputRemarks' style={{ display: issueText ? "block" : "none" }}><textarea style={{ resize: "none" }} rows="6" cols="21" className='formtextcolor' defaultValue={issueText} readOnly/></div>
                                <div className='sectionAinputRemarks' style={{ display: remark ? "block" : "none" }}><textarea style={{ resize: "none" }} rows="6" cols="21" className='formtextcolor' defaultValue={remark} readOnly/></div>
                            </div>
                            <div className='col-sm-3'>
                                <div className='sectionAVoice' style={{ display: voice ? "block" : "none", paddingTop: '5px' }}>Voice Message: </div>   
                            </div>
                            <div className='col-sm-3'>
                                <div className='row'>
                                    <div className='col-sm-9'>
                                        <div className='sectionAinputVoice'  style={{ display: voice ? "block" : "none", paddingTop: '5.5px' }}>
                                            <AudioPlayer
                                                src={playVoice}
                                                autoPlayAfterSrcChange ={false}
                                                style={{
                                                    width: '98%',
                                                }}
                                                showJumpControls={false}
                                                customAdditionalControls={[]}
                                            />
                                        </div>
                                    </div>
                                    <div className='col-sm-3'>
                                        <div style={{ display: voice ? "block" : "none"}}>
                                            <img 
                                                src={DownloadIcon} 
                                                className='table-icon'
                                                style={{maxWidth: '60px'}} 
                                                onClick={() => {downloadVoice()}} 
                                                alt=''
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='freezepane'>
                            <div className='freezepanetitle'>
                                <span className='freezepanespacing'>Section C: Audit Trail</span>
                            </div>
                        </div>
                        <div style={{ display: actionRemarkList?.length > 0 ? "block" : "none" }}>
                            <div className='row loopgrievance'>
                                <div className='col-sm-6'>
                                    {actionRemarkList?.map((actionRemarkList, index) =>
                                        <div className='row ' key={actionRemarkList}>
                                            <div className='col-sm-4'>
                                                <div className='sectionA'>Updated By: </div>
                                                <div className='sectionA'>Date: </div>
                                                <div className='sectionARemarks'>Action Taken (Please take note that this message will be displayed on user's Audit Trail on mobile): </div>
                                                <div className='sectionA'><div style={{ display: actionRemarkList.attachment ? "block" : "none", paddingTop: '10px' }}>Attachments: </div></div>
                                            </div>
                                            <div className='col-sm-8'>
                                            <div className='sectionAinput'><input type="text" className='formtextname' value={actionRemarkList.updatedByName.toLowerCase()} readOnly/></div>
                                            <div className='sectionAinput'><input type="text" className='formtextcolor' value={moment(actionRemarkList.updatedDate).format('DD/MM/YYYY')} readOnly/></div>
                                            <div className='sectionAinputRemarks'><textarea style={{ resize: "none" }} rows="6" cols="21" className='formtextcolor' defaultValue={actionRemarkList.remark} readOnly/></div>
                                            <div className='sectionAinput'>
                                                <div style={{ display: actionRemarkList.attachment ? "block" : "none" }}>
                                                    <img 
                                                        key={index}
                                                        src={DownloadIcon} 
                                                        className='table-icon'
                                                        style={{maxWidth: '50px'}} 
                                                        onClick={() => {downloadPastActionAttachment(actionRemarkList.attachment, index)}} 
                                                        alt=''
                                                    />
                                                </div>
                                            </div>
                                            </div>
                                            <div className='looppane'>
                                            </div>
                                        </div>
                                        )
                                    }
                                </div>
                                <div className='col-sm-6'>
                                    {validateRemarkList?.map((validateRemarkList, index) =>
                                        <div className='row' key={validateRemarkList}>
                                            <div className='col-sm-4'>
                                                <div className='sectionA'>Validated By: </div>
                                                <div className='sectionA'>Date: </div>
                                                <div className='sectionARemarks'>Remark: </div>
                                                <div className='sectionA' style={{ display: validateRemarkList.attachment ? "block" : "none", paddingTop: '10px' }}>Attachments: </div>
                                            </div>
                                            <div className='col-sm-8'>
                                                <div className='sectionAinput'><input type="text" className='formtextname' value={validateRemarkList.updatedByName.toLowerCase()} readOnly/></div>
                                                <div className='sectionAinput'><input type="text" className='formtextcolor' value={moment(validateRemarkList.updatedDate).format('DD/MM/YYYY')} readOnly/></div>
                                                <div className='sectionAinputRemarks'><textarea style={{ resize: "none" }} rows="6" cols="21" className='formtextcolor' defaultValue={validateRemarkList.remark} readOnly/></div>
                                                <div className='sectionAinput'>
                                                    <div style={{ display: validateRemarkList.attachment ? "block" : "none" }}>
                                                        <img 
                                                            key={index}
                                                            src={DownloadIcon} 
                                                            className='table-icon'
                                                            style={{maxWidth: '50px'}} 
                                                            onClick={() => {downloadPastvalidateAttachment(validateRemarkList.attachment, index)}} 
                                                            alt=''
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='looppane'>
                                            </div>
                                        </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>


                        {/* PIClogic */}
                        {( isPIC && grievanceStatus == 1 && <div>
                            <form onSubmit={onSubmitPIC}>
                                <div className='row readgrievance'>
                                    <div className='col-sm-3'>
                                        <div className='sectionA'>Priority: </div>
                                        <div className='sectionA'>Updated By: </div>
                                        <div className='sectionA'>Date: </div>
                                    </div>
                                    <div className='col-sm-3'>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={priority} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextname' value={currentUser} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={todayDate} readOnly /></div>
                                    </div>
                                    <div className='col-sm-6'></div>
                                    <div className='col-sm-3'>
                                        <div className='sectionARemarks'>Action Taken (Please take note that this message will be displayed on user's Audit Trail on mobile): </div>
                                    </div>
                                    <div className='col-sm-9'>
                                        <div className='sectionAinputRemarks'>
                                            <div className='form-control grievancePIC-form'>
                                                <textarea rows="6" cols="21"
                                                    placeholder='Insert action taken here...'
                                                    style={{ width: '99%', resize: "none" }}
                                                    defaultValue={actionRemark}
                                                    onChange={(e) => setAction(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-sm-3'>
                                        <div className={
                                            (uploadImage && (uploadImage?.length === 6)) ? 'sectionA6attachment' :
                                            (uploadImage && (uploadImage?.length === 7)) ? 'sectionA7attachment' : 
                                            (uploadImage && (uploadImage?.length === 8)) ? 'sectionA8attachment' : 
                                            (uploadImage && (uploadImage?.length === 9)) ? 'sectionA9attachment' : 
                                            (uploadImage && (uploadImage?.length === 10)) ? 'sectionA10attachment' : 
                                            'sectionAattachment'
                                        }>
                                            Upload Image (Please take note that this message will be displayed on user's Audit Trail on mobile): 
                                        </div>
                                    </div>
                                    <div className='col-sm-3'>
                                        <div className={
                                            (uploadImage && (uploadImage?.length === 6)) ? 'sectionAinput6attachment' :
                                            (uploadImage && (uploadImage?.length === 7)) ? 'sectionAinput7attachment' : 
                                            (uploadImage && (uploadImage?.length === 8)) ? 'sectionAinput8attachment' : 
                                            (uploadImage && (uploadImage?.length === 9)) ? 'sectionAinput9attachment' : 
                                            (uploadImage && (uploadImage?.length === 10)) ? 'sectionAinput10attachment' : 
                                            'sectionAinputattachment'
                                        }>
                                            <AttachmentUploader getImageUrl={getImageUrl} uploadImage={uploadImage} originalImageName={originalImageName} />
                                        </div>
                                    </div>
                                    <div className='col-sm-6' style={{ position: 'relative' }}>
                                        <Button className="grievancesave" as='input' type='button' value='Save' onClick={saveAction}/>
                                        <Button className="grievancesubmit" as='input' type='submit' value='Submit' />
                                    </div>
                                </div>
                            </form>
                        </div>)}
                        {( isPIC && grievanceStatus == 2 && <div>
                            <div className='row readgrievance'>
                                <div className='col-sm-3'>
                                    <div className='sectionA'>Priority: </div>
                                    <div className='sectionA'>Updated By: </div>
                                    <div className='sectionA'>Date: </div>      
                                </div>
                                <div className='col-sm-3'>
                                    <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={priority} readOnly/></div>
                                    <div className='sectionAinput'><input type="text" className='formtextname' value={updatename} readOnly/></div>
                                    <div className='sectionAinput'><input type="text" className='formtextcolor' value={updateTime} readOnly /></div>
                                </div>
                                <div className='col-sm-6'>
                                    <div style={{ display: actionAttachment ? "block" : "none" }}>
                                        <div className='sectionAImageTrail'>Attachments (Please take note that this message will be displayed on user's Audit Trail on mobile):</div> 
                                        <img 
                                            src={DownloadIcon} 
                                            className='table-icon'
                                            style={{maxWidth: '6vw'}} 
                                            onClick={() => {downloadactionAttachment()}} 
                                            alt=''
                                        />
                                    </div>
                                </div>
                                <div className='col-sm-3'>
                                    <div className='sectionARemarks'>Action Taken (Please take note that this message will be displayed on user's Audit Trail on mobile): </div>
                                </div>
                                <div className='col-sm-9'>
                                    <div className='sectionAinputRemarks'><textarea style={{ resize: "none" }} rows="6" cols="21" className='formtextcolor' defaultValue={actionRemark} readOnly/></div>
                                </div>
                                <div className='col-sm-3'>
                                    <div className='sectionA'>Status: </div>
                                </div>
                                <div className='col-sm-3'>
                                    <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={currentStatusName} readOnly/></div>   
                                </div>
                            </div>
                        </div>)}
                        {( isPIC && grievanceStatus == 3 && <div>
                            <div style={{ display: userType == 1 ? "block" : "none" }}>
                                <div className='row readgrievance'>
                                    <div className='col-sm-3'>
                                        <div className='sectionA'>Priority: </div>
                                        <div className='sectionA'>Updated By: </div>
                                        <div className='sectionA'>Date: </div>    
                                    </div>
                                    <div className='col-sm-3'>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={priority} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextname' value={closename} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' value={closedTime} readOnly /></div>  
                                    </div>
                                    <div className='col-sm-6'>
                                        <div style={{ display: actionAttachment ? "block" : "none" }}>
                                            <div className='sectionAImageTrail'>Attachments (Please take note that this message will be displayed on user's Audit Trail on mobile):</div> 
                                            <img 
                                                src={DownloadIcon} 
                                                className='table-icon'
                                                style={{maxWidth: '6vw'}} 
                                                onClick={() => {downloadactionAttachment()}} 
                                                alt=''
                                            />
                                        </div>
                                    </div>
                                    <div className='col-sm-3'>
                                        <div className='sectionARemarks'>Action Taken (Please take note that this message will be displayed on user's Audit Trail on mobile): </div>
                                    </div>
                                    <div className='col-sm-9'>
                                        <div className='sectionAinputRemarks'><textarea style={{ resize: "none" }} rows="6" cols="21" className='formtextcolor' defaultValue={actionRemark} readOnly/></div>
                                    </div>
                                    <div className='col-sm-3'>
                                        <div className='sectionA'>Status: </div>
                                    </div>
                                    <div className='col-sm-3'>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={currentStatusName} readOnly/></div> 
                                    </div>
                                </div>
                            </div>
                            <div style={{ display: userType == 2  && updateID === closeID ? "block" : "none" }}>
                                <div className='row readgrievance'>
                                    <div className='col-sm-3'>
                                        <div className='sectionA'>Priority: </div>
                                        <div className='sectionA'>Updated By: </div>
                                        <div className='sectionA'>Date: </div>                             
                                    </div>
                                    <div className='col-sm-3'>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={priority} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextname' value={closename} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' value={closedTime} readOnly /></div>        
                                    </div>
                                    <div className='col-sm-6'>
                                        <div style={{ display: actionAttachment ? "block" : "none" }}>
                                            <div className='sectionAImageTrail'>Attachments (Please take note that this message will be displayed on user's Audit Trail on mobile):</div> 
                                            <img 
                                                src={DownloadIcon} 
                                                className='table-icon'
                                                style={{maxWidth: '6vw'}} 
                                                onClick={() => {downloadactionAttachment()}} 
                                                alt=''
                                            />
                                        </div>
                                    </div>
                                    <div className='col-sm-3'>
                                        <div className='sectionARemarks'>Action Taken (Please take note that this message will be displayed on user's Audit Trail on mobile): </div>
                                    </div>
                                    <div className='col-sm-9'>
                                        <div className='sectionAinputRemarks'><textarea style={{ resize: "none" }} rows="6" cols="21" className='formtextcolor' defaultValue={actionRemark} readOnly/></div>
                                    </div>
                                    <div className='col-sm-3'>
                                        <div className='sectionA'>Status: </div>
                                    </div>
                                    <div className='col-sm-3'>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={currentStatusName} readOnly/></div> 
                                    </div>
                                </div>
                            </div>
                            <div style={{ display: userType == 2 && updateID !== closeID ? "block" : "none" }}>
                                <div className='row readgrievance'>
                                    <div className='col-sm-2'>
                                        <div className='sectionA'>Priority: </div>
                                        <div className='sectionA'>Updated By: </div>
                                        <div className='sectionA'>Date: </div>
                                        <div className='sectionARemarks'>Action Taken (Please take note that this message will be displayed on user's Audit Trail on mobile): </div>
                                        <div className='sectionAuditAttachmentCloseValidationVer' style={{ display: actionAttachment ? "block" : "none", paddingTop: '10px' }}>Attachments (Please take note that this message will be displayed on user's Audit Trail on mobile): </div>
                                    </div>
                                    <div className='col-sm-4'>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={priority} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextname' value={updatename} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' value={updateTime} readOnly /></div>
                                        <div className='sectionAinputRemarks'><textarea style={{ resize: "none" }} rows="6" cols="21" className='formtextcolor' defaultValue={actionRemark} readOnly/></div>
                                        <div className='sectionAuditinputAttachmentCloseValidationVer' style={{ display: actionAttachment ? "block" : "none" }}>
                                            <img 
                                                src={DownloadIcon} 
                                                className='table-icon'
                                                style={{maxWidth: '50px'}} 
                                                onClick={() => {downloadactionAttachment()}} 
                                                alt=''
                                            />
                                        </div>
                                    </div>
                                    <div className='col-sm-2'>
                                        <div className='sectionA'>Validated By: </div>
                                        <div className='sectionA'>Validated Date: </div>
                                        <div className='sectionA'>Status: </div>
                                        <div className='sectionARemarks'>Remarks: </div>
                                        <div className='sectionAuditAttachment' style={{ display: validateAttachment ? "block" : "none", paddingTop: '10px' }}>Attachments: </div>  
                                    </div>
                                    <div className='col-sm-4'>
                                        <div className='sectionAinput'><input type="text" className='formtextname' value={closename} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' value={closedTime} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={currentStatusName} readOnly/></div>
                                        <div className='sectionAinputRemarks'><textarea style={{ resize: "none" }} rows="6" cols="21" className='formtextcolor' defaultValue={closeRemark} readOnly /></div>
                                        <div className='sectionAuditinputattachment' style={{ display: validateAttachment ? "block" : "none" }}>
                                            <img 
                                                src={DownloadIcon} 
                                                className='table-icon'
                                                style={{maxWidth: '50px'}} 
                                                onClick={() => {downloadvalidateAttachment()}} 
                                                alt=''
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>)}
                        {( isPIC && grievanceStatus == 4 && <div>
                            <form onSubmit={onSubmitPIC}>
                                <div className='row readgrievance'>
                                    <div className='col-sm-2'>
                                        <div className='sectionA'>Priority: </div>
                                        <div className='sectionA'>Updated By: </div>
                                        <div className='sectionA'>Date: </div>      
                                    </div>
                                    <div className='col-sm-4'>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={priority} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextname' value={currentUser} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={todayDate} readOnly /></div>            
                                    </div>
                                    <div className='col-sm-6'></div>
                                    <div className='col-sm-2'>
                                        <div className='sectionARemarks'>Action Taken (Please take note that this message will be displayed on user's Audit Trail on mobile): </div>
                                    </div>
                                    <div className='col-sm-10'>
                                        <div className='sectionAinputRemarks'>
                                            <div className='form-control grievancePIC-form'>
                                                <textarea rows="6" cols="21"
                                                    placeholder='Insert action taken here...'
                                                    style={{ width: '100%', resize: "none" }}
                                                    defaultValue={""}
                                                    onChange={(e) => setAction(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-sm-2'>
                                        <div className={
                                            (uploadImage && (uploadImage?.length === 6)) ? 'sectionA6attachment' :
                                            (uploadImage && (uploadImage?.length === 7)) ? 'sectionA7attachment' : 
                                            (uploadImage && (uploadImage?.length === 8)) ? 'sectionA8attachment' : 
                                            (uploadImage && (uploadImage?.length === 9)) ? 'sectionA9attachment' : 
                                            (uploadImage && (uploadImage?.length === 10)) ? 'sectionA10attachment' : 
                                            'sectionAattachment'
                                        }>
                                            Upload Image (Please take note that this message will be displayed on user's Audit Trail on mobile): 
                                        </div>
                                    </div>
                                    <div className='col-sm-4'>
                                        <div className={
                                            (uploadImage && (uploadImage?.length === 6)) ? 'sectionAinput6attachment' :
                                            (uploadImage && (uploadImage?.length === 7)) ? 'sectionAinput7attachment' : 
                                            (uploadImage && (uploadImage?.length === 8)) ? 'sectionAinput8attachment' : 
                                            (uploadImage && (uploadImage?.length === 9)) ? 'sectionAinput9attachment' : 
                                            (uploadImage && (uploadImage?.length === 10)) ? 'sectionAinput10attachment' : 
                                            'sectionAinputattachment'
                                        }>
                                            <AttachmentUploader getImageUrl={getImageUrl} uploadImage={uploadImage} originalImageName={originalImageName} />
                                        </div> 
                                    </div>
                                    <div className='col-sm-6' style={{ position: 'relative' }}>
                                        <Button className="grievancesave" as='input' type='button' value='Save' onClick={saveAction}/>
                                        <Button className="grievancesubmit" as='input' type='submit' value='Submit' />
                                    </div>
                                </div>
                            </form>
                        </div>)}
                        {( isPIC && grievanceStatus == 5 && <div>
                            <form onSubmit={onSubmitPIC}>
                                <div className='row readgrievance'>
                                    <div className='col-sm-3'>
                                        <div className='sectionA'>Priority: </div>
                                        <div className='sectionA'>Updated By: </div>
                                        <div className='sectionA'>Date: </div>
                                    </div>
                                    <div className='col-sm-3'>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={priority} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextname' value={currentUser} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={todayDate} readOnly /></div>
                                    </div>
                                    <div className='col-sm-6'></div>
                                    <div className='col-sm-3'>
                                        <div className='sectionARemarks'>Action Taken (Please take note that this message will be displayed on user's Audit Trail on mobile): </div>
                                    </div>
                                    <div className='col-sm-9'>
                                        <div className='sectionAinputRemarks'>
                                            <div className='form-control grievancePIC-form'>
                                                <textarea rows="6" cols="21"
                                                    placeholder='Insert action taken here...'
                                                    style={{ width: '99%', resize: "none" }}
                                                    defaultValue={actionRemark}
                                                    onChange={(e) => setAction(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-sm-3'>
                                        <div className='sectionAuditAttachment' style={{ display: actionAttachment ? "block" : "none", paddingTop: '10px' }}>Attachment Log: </div>
                                        <div className={
                                            (uploadImage && (uploadImage?.length === 6)) ? 'sectionA6attachment' :
                                            (uploadImage && (uploadImage?.length === 7)) ? 'sectionA7attachment' : 
                                            (uploadImage && (uploadImage?.length === 8)) ? 'sectionA8attachment' : 
                                            (uploadImage && (uploadImage?.length === 9)) ? 'sectionA9attachment' : 
                                            (uploadImage && (uploadImage?.length === 10)) ? 'sectionA10attachment' : 
                                            'sectionAattachment'
                                        }>
                                            Upload Image (Please take note that this message will be displayed on user's Audit Trail on mobile): 
                                        </div>
                                    </div>
                                    <div className='col-sm-3'>
                                        <div className='sectionAuditinputattachment' style={{ display: actionAttachment ? "block" : "none" }}>
                                            <img 
                                                src={DownloadIcon} 
                                                className='table-icon'
                                                style={{maxWidth: '50px'}} 
                                                onClick={() => {downloadactionAttachment()}} 
                                                alt=''
                                            />
                                        </div>
                                        <div className={
                                            (uploadImage && (uploadImage?.length === 6)) ? 'sectionAinput6attachment' :
                                            (uploadImage && (uploadImage?.length === 7)) ? 'sectionAinput7attachment' : 
                                            (uploadImage && (uploadImage?.length === 8)) ? 'sectionAinput8attachment' : 
                                            (uploadImage && (uploadImage?.length === 9)) ? 'sectionAinput9attachment' : 
                                            (uploadImage && (uploadImage?.length === 10)) ? 'sectionAinput10attachment' : 
                                            'sectionAinputattachment'
                                        }>
                                            <AttachmentUploader getImageUrl={getImageUrl} uploadImage={uploadImage} originalImageName={originalImageName} pastAttachment={actionAttachment} />
                                        </div>
                                    </div>
                                    <div className='col-sm-6' style={{ position: 'relative' }}>
                                        <Button className="grievancesave" as='input' type='button' value='Save' onClick={saveAction}/>
                                        <Button className="grievancesubmit" as='input' type='submit' value='Submit' />
                                    </div>
                                </div>
                            </form>
                        </div>)}
                        {( isPIC && grievanceStatus == 6 && <div>
                            <div className='row readgrievance'>
                                <div className='col-sm-2'>
                                    <div className='sectionA'>Priority: </div>
                                    <div className='sectionA'>Updated By: </div>
                                    <div className='sectionA'>Date: </div>
                                    <div className='sectionARemarks'>Action Taken (Please take note that this message will be displayed on user's Audit Trail on mobile): </div>
                                    <div className='sectionAuditAttachmentCloseValidationVer' style={{ display: actionAttachment ? "block" : "none", paddingTop: '10px' }}>Attachments (Please take note that this message will be displayed on user's Audit Trail on mobile): </div>
                                </div>
                                <div className='col-sm-4'>
                                    <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={priority} readOnly/></div>
                                    <div className='sectionAinput'><input type="text" className='formtextname' value={updatename} readOnly/></div>
                                    <div className='sectionAinput'><input type="text" className='formtextcolor' value={updateTime} readOnly /></div>
                                    <div className='sectionAinputRemarks'><textarea style={{ resize: "none" }} rows="6" cols="21" className='formtextcolor' defaultValue={actionRemark} readOnly/></div>
                                    <div className='sectionAuditinputAttachmentCloseValidationVer' style={{ display: actionAttachment ? "block" : "none" }}>
                                        <img 
                                            src={DownloadIcon} 
                                            className='table-icon'
                                            style={{maxWidth: '50px'}} 
                                            onClick={() => {downloadactionAttachment()}} 
                                            alt=''
                                        />
                                    </div>
                                </div>
                                <div className='col-sm-2'>
                                    <div className='sectionA'>Validated By: </div>
                                    <div className='sectionA'>Validated Date: </div>
                                    <div className='sectionA'>Status: </div>
                                    <div className='sectionARemarks'>Remarks: </div>
                                    <div className='sectionAuditAttachment' style={{ display: validateAttachment ? "block" : "none", paddingTop: '10px' }}>Attachments: </div>  
                                </div>
                                <div className='col-sm-4'>
                                    <div className='sectionAinput'><input type="text" className='formtextname' value={validatename} readOnly/></div>
                                    <div className='sectionAinput'><input type="text" className='formtextcolor' value={validateTime} readOnly/></div>
                                    <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={currentStatusName} readOnly/></div>
                                    <div className='sectionAinputRemarks'><textarea style={{ resize: "none" }} rows="6" cols="21" className='formtextcolor' defaultValue={validateRemark} readOnly /></div>
                                    <div className='sectionAuditinputattachment' style={{ display: validateAttachment ? "block" : "none" }}>
                                        <img 
                                            src={DownloadIcon} 
                                            className='table-icon'
                                            style={{maxWidth: '50px'}} 
                                            onClick={() => {downloadvalidateAttachment()}} 
                                            alt=''
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>)}



                        {/* FHRlogic */}
                        {( isFHR && grievanceStatus == 1 && <div>
                        <div style={{ display: userType == 2 ? "block" : "none" }}>
                            <form onSubmit={onSubmitFHR}>
                                <div className='row readgrievance'>
                                    <div className='col-sm-3'>
                                        <div className='sectionA'>Priority: </div>
                                        <div className='sectionA'>Updated By: </div>
                                        <div className='sectionA'>Date: </div>
                                    </div>
                                    <div className='col-sm-3'>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={priority} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextname' value={currentUser} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={todayDate} readOnly /></div>
                                    </div>
                                    <div className='col-sm-6'></div>
                                    <div className='col-sm-3'>
                                        <div className='sectionARemarks'>Action Taken (Please take note that this message will be displayed on user's Audit Trail on mobile): </div>
                                    </div>
                                    <div className='col-sm-9'>
                                        <div className='sectionAinputRemarks'>
                                            <div className='form-control grievancePIC-form'>
                                                <textarea rows="6" cols="21"
                                                    placeholder='Insert action taken here...'
                                                    style={{ width: '99%', resize: "none" }}
                                                    defaultValue={actionRemark}
                                                    onChange={(e) => setAction(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-sm-3'>
                                        <div className={
                                            (uploadImage && (uploadImage?.length === 6)) ? 'sectionA6attachment' :
                                            (uploadImage && (uploadImage?.length === 7)) ? 'sectionA7attachment' : 
                                            (uploadImage && (uploadImage?.length === 8)) ? 'sectionA8attachment' : 
                                            (uploadImage && (uploadImage?.length === 9)) ? 'sectionA9attachment' : 
                                            (uploadImage && (uploadImage?.length === 10)) ? 'sectionA10attachment' : 
                                            'sectionAattachment'
                                        }>
                                            Upload Image (Please take note that this message will be displayed on user's Audit Trail on mobile): 
                                        </div>
                                    </div>
                                    <div className='col-sm-3'>
                                        <div className={
                                            (uploadImage && (uploadImage?.length === 6)) ? 'sectionAinput6attachment' :
                                            (uploadImage && (uploadImage?.length === 7)) ? 'sectionAinput7attachment' : 
                                            (uploadImage && (uploadImage?.length === 8)) ? 'sectionAinput8attachment' : 
                                            (uploadImage && (uploadImage?.length === 9)) ? 'sectionAinput9attachment' : 
                                            (uploadImage && (uploadImage?.length === 10)) ? 'sectionAinput10attachment' : 
                                            'sectionAinputattachment'
                                        }>
                                            <AttachmentUploader getImageUrl={getImageUrl} uploadImage={uploadImage} originalImageName={originalImageName} />
                                        </div> 
                                    </div>
                                    <div className='col-sm-6' style={{ position: 'relative' }}>
                                        <Button className="grievancesave" as='input' type='button' value='Save' onClick={saveAction}/>
                                        <Button className="grievancesubmit" as='input' type='submit' value='Submit' />
                                    </div>
                                </div>
                            </form>
                        </div>
                        </div>)}
                        {( isFHR && grievanceStatus == 2 && <div>
                            <form onSubmit={onSubmitFHR}>
                                <div className='row readgrievance'>
                                    <div className='col-sm-2'>
                                        <div className='sectionA'>Priority: </div>
                                        <div className='sectionA'>Updated By: </div>
                                        <div className='sectionA'>Date: </div>
                                        <div className='sectionARemarks'>Action Taken (Please take note that this message will be displayed on user's Audit Trail on mobile): </div>
                                        <div className='sectionAuditAttachmentCloseValidationVer' style={{ display: actionAttachment ? "block" : "none", paddingTop: '10px' }}>Attachments (Please take note that this message will be displayed on user's Audit Trail on mobile): </div>     
                                    </div>
                                    <div className='col-sm-4'>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={priority} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextname' value={updatename} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' value={updateTime} readOnly /></div>
                                        <div className='sectionAinputRemarks'><textarea style={{ resize: "none" }} rows="6" cols="21" className='formtextcolor' defaultValue={actionRemark} readOnly/></div>
                                        <div className='sectionAuditinputAttachmentCloseValidationVer' style={{ display: actionAttachment ? "block" : "none" }}>
                                            <img 
                                                src={DownloadIcon} 
                                                className='table-icon'
                                                style={{maxWidth: '50px'}} 
                                                onClick={() => {downloadactionAttachment()}} 
                                                alt=''
                                            />
                                        </div>  
                                    </div>
                                    <div className='col-sm-2'>
                                        <div className='sectionA'>Validated By: </div>
                                        <div className='sectionA'>Validated Date: </div>
                                        <div className='sectionARemarks'>Remark: </div>
                                        <div className={
                                            (uploadImage && (uploadImage?.length === 4)) ? 'sectionvalidate4attachment' :
                                            (uploadImage && (uploadImage?.length === 5)) ? 'sectionvalidate5attachment' :
                                            (uploadImage && (uploadImage?.length === 6)) ? 'sectionvalidate6attachment' :
                                            (uploadImage && (uploadImage?.length === 7)) ? 'sectionvalidate7attachment' : 
                                            (uploadImage && (uploadImage?.length === 8)) ? 'sectionvalidate8attachment' : 
                                            (uploadImage && (uploadImage?.length === 9)) ? 'sectionvalidate9attachment' : 
                                            (uploadImage && (uploadImage?.length === 10)) ? 'sectionvalidate10attachment' : 
                                            'sectionvalidateattachment'
                                        }>
                                            Upload Image: 
                                        </div>
                                        <div className='sectionAbetween'></div>  
                                        <div className='sectionA'>Status: </div>    
                                    </div>
                                    <div className='col-sm-4'>
                                        <div className='sectionAinput'><input type="text" className='formtextname' value={currentUser} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={todayDate} readOnly/></div>
                                        <div className='sectionAinputRemarks'>
                                            <div className='form-control grievancePIC-form'>
                                                <textarea rows="6" cols="21"
                                                    placeholder='Please insert remarks here...'
                                                    style={{ width: '101.5%', resize: "none" }}
                                                    defaultValue={""}
                                                    onChange={(e) => setValidate(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className={
                                            (uploadImage && (uploadImage?.length === 4)) ? 'sectioninputvalidate4attachment' :
                                            (uploadImage && (uploadImage?.length === 5)) ? 'sectioninputvalidate5attachment' :
                                            (uploadImage && (uploadImage?.length === 6)) ? 'sectioninputvalidate6attachment' :
                                            (uploadImage && (uploadImage?.length === 7)) ? 'sectioninputvalidate7attachment' : 
                                            (uploadImage && (uploadImage?.length === 8)) ? 'sectioninputvalidate8attachment' : 
                                            (uploadImage && (uploadImage?.length === 9)) ? 'sectioninputvalidate9attachment' : 
                                            (uploadImage && (uploadImage?.length === 10)) ? 'sectioninputvalidate10attachment' : 
                                            'sectioninputvalidateattachment'
                                        }>
                                        <AttachmentUploader getImageUrl={getImageUrl} uploadImage={uploadImage} originalImageName={originalImageName} />
                                        </div>
                                        <div className='sectionAbetween'></div> 
                                        <div className='form-control grievancePIC-form'>
                                            <input
                                                className='grievanceradio'
                                                type='radio'
                                                name='radiooption'
                                                value={4}
                                                onClick={(e) => setStatus(e.target.value)}
                                            />
                                            <label className='radiodesc'>Reject</label>
                                            <input
                                                className='grievanceradio'
                                                type='radio'
                                                name='radiooption'
                                                value={3}
                                                onClick={(e) => setStatus(e.target.value)}
                                            />
                                            <label className='radiodesc'>Close</label>
                                        </div>
                                        <div className='sectionA'></div>
                                        <Button style={{ float:"right" }} as='input' type='submit' value='Submit' />
                                        <Button style={{ float:"right" }} as='input' type='button' value='Save' onClick={saveValidate}/>
                                    </div>
                                </div>
                            </form>
                        </div>)}
                        {( isFHR && grievanceStatus == 3 && <div>
                            <div style={{ display: updateID === closeID ? "block" : "none" }}>
                                <div className='row readgrievance'>
                                    <div className='col-sm-3'>
                                        <div className='sectionA'>Priority: </div>
                                        <div className='sectionA'>Updated By: </div>
                                        <div className='sectionA'>Date: </div>  
                                    </div>
                                    <div className='col-sm-3'>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={priority} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextname' value={closename} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' value={closedTime} readOnly /></div>   
                                    </div>
                                    <div className='col-sm-6'></div>
                                    <div className='col-sm-3'>
                                        <div className='sectionARemarks'>Action Taken (Please take note that this message will be displayed on user's Audit Trail on mobile): </div>
                                    </div>
                                    <div className='col-sm-9'>
                                        <div className='sectionAinputRemarks'><textarea style={{ resize: "none" }} rows="6" cols="21" className='formtextcolor' defaultValue={actionRemark} readOnly/></div>
                                    </div>
                                    <div className='col-sm-3'>
                                        <div className='sectionAuditAttachmentCloseValidationVer' style={{ display: actionAttachment ? "block" : "none", paddingTop: '10px' }}>Attachments (Please take note that this message will be displayed on user's Audit Trail on mobile): </div>
                                        <div className='sectionA'>Status: </div>    
                                    </div>
                                    <div className='col-sm-3'>
                                        <div className='sectionAuditinputAttachmentCloseValidationVer' style={{ display: actionAttachment ? "block" : "none" }}>
                                            <img 
                                                src={DownloadIcon} 
                                                className='table-icon'
                                                style={{maxWidth: '50px'}} 
                                                onClick={() => {downloadactionAttachment()}} 
                                                alt=''
                                            />
                                        </div>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={currentStatusName} readOnly/></div>
                                    </div>
                                </div>
                            </div>
                            <div style={{ display: updateID !== closeID ? "block" : "none" }}>
                                <div className='row readgrievance'>
                                    <div className='col-sm-2'>
                                        <div className='sectionA'>Priority: </div>
                                        <div className='sectionA'>Updated By: </div>
                                        <div className='sectionA'>Date: </div>
                                        <div className='sectionARemarks'>Action Taken (Please take note that this message will be displayed on user's Audit Trail on mobile): </div>
                                        <div className='sectionAuditAttachmentCloseValidationVer' style={{ display: actionAttachment ? "block" : "none", paddingTop: '10px' }}>Attachments (Please take note that this message will be displayed on user's Audit Trail on mobile): </div>
                                    </div>
                                    <div className='col-sm-4'>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={priority} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextname' value={updatename} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' value={updateTime} readOnly /></div>
                                        <div className='sectionAinputRemarks'><textarea style={{ resize: "none" }} rows="6" cols="21" className='formtextcolor' defaultValue={actionRemark} readOnly/></div>
                                        <div className='sectionAuditinputAttachmentCloseValidationVer' style={{ display: actionAttachment ? "block" : "none" }}>
                                            <img 
                                                src={DownloadIcon} 
                                                className='table-icon'
                                                style={{maxWidth: '50px'}} 
                                                onClick={() => {downloadactionAttachment()}} 
                                                alt=''
                                            />
                                        </div>
                                    </div>
                                    <div className='col-sm-2'>
                                        <div className='sectionA'>Validated By: </div>
                                        <div className='sectionA'>Validated Date: </div>
                                        <div className='sectionA'>Status: </div>
                                        <div className='sectionARemarks'>Remarks: </div>
                                        <div className='sectionAuditAttachment' style={{ display: validateAttachment ? "block" : "none", paddingTop: '10px' }}>Attachments: </div>  
                                    </div>
                                    <div className='col-sm-4'>
                                        <div className='sectionAinput'><input type="text" className='formtextname' value={closename} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' value={closedTime} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={currentStatusName} readOnly/></div>
                                        <div className='sectionAinputRemarks'><textarea style={{ resize: "none" }} rows="6" cols="21" className='formtextcolor' defaultValue={closeRemark} readOnly /></div>
                                        <div className='sectionAuditinputattachment' style={{ display: validateAttachment ? "block" : "none" }}>
                                            <img 
                                                src={DownloadIcon} 
                                                className='table-icon'
                                                style={{maxWidth: '50px'}} 
                                                onClick={() => {downloadvalidateAttachment()}} 
                                                alt=''
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>)}
                        {( isFHR && grievanceStatus == 5 && <div>
                            <div style={{ display: userType == 2 ? "block" : "none" }}>
                                <form onSubmit={onSubmitFHR}>
                                    <div className='row readgrievance'>
                                        <div className='col-sm-3'>
                                            <div className='sectionA'>Priority: </div>
                                            <div className='sectionA'>Updated By: </div>
                                            <div className='sectionA'>Date: </div>
                                        </div>
                                        <div className='col-sm-3'>
                                            <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={priority} readOnly/></div>
                                            <div className='sectionAinput'><input type="text" className='formtextname' value={currentUser} readOnly/></div>
                                            <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={todayDate} readOnly /></div>
                                        </div>
                                        <div className='col-sm-6'></div>
                                        <div className='col-sm-3'>
                                            <div className='sectionARemarks'>Action Taken (Please take note that this message will be displayed on user's Audit Trail on mobile): </div>
                                        </div>
                                        <div className='col-sm-9'>
                                            <div className='sectionAinputRemarks'>
                                                <div className='form-control grievancePIC-form'>
                                                    <textarea rows="6" cols="21"
                                                        placeholder='Insert action taken here...'
                                                        style={{ width: '99%', resize: "none" }}
                                                        defaultValue={actionRemark}
                                                        onChange={(e) => setAction(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-sm-3'>
                                            <div className='sectionAuditAttachment' style={{ display: actionAttachment ? "block" : "none", paddingTop: '10px' }}>Attachment Log: </div>
                                            <div className={
                                                (uploadImage && (uploadImage?.length === 6)) ? 'sectionA6attachment' :
                                                (uploadImage && (uploadImage?.length === 7)) ? 'sectionA7attachment' : 
                                                (uploadImage && (uploadImage?.length === 8)) ? 'sectionA8attachment' : 
                                                (uploadImage && (uploadImage?.length === 9)) ? 'sectionA9attachment' : 
                                                (uploadImage && (uploadImage?.length === 10)) ? 'sectionA10attachment' : 
                                                'sectionAattachment'
                                            }>
                                                Upload Image (Please take note that this message will be displayed on user's Audit Trail on mobile): 
                                            </div>
                                        </div>
                                        <div className='col-sm-3'>
                                            <div className='sectionAuditinputattachment' style={{ display: actionAttachment ? "block" : "none" }}>
                                                <img 
                                                    src={DownloadIcon} 
                                                    className='table-icon'
                                                    style={{maxWidth: '50px'}} 
                                                    onClick={() => {downloadactionAttachment()}} 
                                                    alt=''
                                                />
                                            </div>
                                            <div className={
                                                (uploadImage && (uploadImage?.length === 6)) ? 'sectionAinput6attachment' :
                                                (uploadImage && (uploadImage?.length === 7)) ? 'sectionAinput7attachment' : 
                                                (uploadImage && (uploadImage?.length === 8)) ? 'sectionAinput8attachment' : 
                                                (uploadImage && (uploadImage?.length === 9)) ? 'sectionAinput9attachment' : 
                                                (uploadImage && (uploadImage?.length === 10)) ? 'sectionAinput10attachment' : 
                                                'sectionAinputattachment'
                                            }>
                                                <AttachmentUploader getImageUrl={getImageUrl} uploadImage={uploadImage} originalImageName={originalImageName} pastAttachment={actionAttachment} />
                                            </div> 
                                        </div>
                                        <div className='col-sm-6' style={{ position: 'relative' }}>
                                            <Button className="grievancesave" as='input' type='button' value='Save' onClick={saveAction}/>
                                            <Button className="grievancesubmit" as='input' type='submit' value='Submit' />
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>)}
                        {( isFHR && grievanceStatus == 6 && <div>
                            <form onSubmit={onSubmitFHR}>
                                <div className='row readgrievance'>
                                    <div className='col-sm-2'>
                                        <div className='sectionA'>Priority: </div>
                                        <div className='sectionA'>Updated By: </div>
                                        <div className='sectionA'>Date: </div>
                                        <div className='sectionARemarks'>Action Taken (Please take note that this message will be displayed on user's Audit Trail on mobile): </div>
                                        <div className='sectionAuditAttachmentCloseValidationVer' style={{ display: actionAttachment ? "block" : "none", paddingTop: '10px' }}>Attachments (Please take note that this message will be displayed on user's Audit Trail on mobile): </div>     
                                    </div>
                                    <div className='col-sm-4'>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={priority} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextname' value={updatename} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' value={updateTime} readOnly /></div>
                                        <div className='sectionAinputRemarks'><textarea style={{ resize: "none" }} rows="6" cols="21" className='formtextcolor' defaultValue={actionRemark} readOnly/></div>
                                        <div className='sectionAuditinputAttachmentCloseValidationVer' style={{ display: actionAttachment ? "block" : "none" }}>
                                            <img 
                                                src={DownloadIcon} 
                                                className='table-icon'
                                                style={{maxWidth: '50px'}} 
                                                onClick={() => {downloadactionAttachment()}} 
                                                alt=''
                                            />
                                        </div>  
                                    </div>
                                    <div className='col-sm-2'>
                                        <div className='sectionA'>Validated By: </div>
                                        <div className='sectionA'>Validated Date: </div>
                                        <div className='sectionARemarks'>Remark: </div>
                                        <div className='sectionAuditAttachment' style={{ display: validateAttachment ? "block" : "none", paddingTop: '10px' }}>Attachment Log: </div> 
                                        <div className={
                                            (uploadImage && (uploadImage?.length === 4)) ? 'sectionvalidate4attachment' :
                                            (uploadImage && (uploadImage?.length === 5)) ? 'sectionvalidate5attachment' :
                                            (uploadImage && (uploadImage?.length === 6)) ? 'sectionvalidate6attachment' :
                                            (uploadImage && (uploadImage?.length === 7)) ? 'sectionvalidate7attachment' : 
                                            (uploadImage && (uploadImage?.length === 8)) ? 'sectionvalidate8attachment' : 
                                            (uploadImage && (uploadImage?.length === 9)) ? 'sectionvalidate9attachment' : 
                                            (uploadImage && (uploadImage?.length === 10)) ? 'sectionvalidate10attachment' : 
                                            'sectionvalidateattachment'
                                        }>
                                            Upload Image: 
                                        </div>
                                        <div className='sectionAbetween'></div>  
                                        <div className='sectionA'>Status: </div>    
                                    </div>
                                    <div className='col-sm-4'>
                                        <div className='sectionAinput'><input type="text" className='formtextname' value={currentUser} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={todayDate} readOnly/></div>
                                        <div className='sectionAinputRemarks'>
                                            <div className='form-control grievancePIC-form'>
                                                <textarea rows="6" cols="21"
                                                    placeholder='Please insert remarks here...'
                                                    style={{ width: '101.5%', resize: "none" }}
                                                    defaultValue={validateRemark}
                                                    onChange={(e) => setValidate(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className='sectionAuditinputattachment' style={{ display: validateAttachment ? "block" : "none" }}>
                                            <img 
                                                src={DownloadIcon} 
                                                className='table-icon'
                                                style={{maxWidth: '50px'}} 
                                                onClick={() => {downloadvalidateAttachment()}} 
                                                alt=''
                                            />
                                        </div>
                                        <div className={
                                            (uploadImage && (uploadImage?.length === 4)) ? 'sectioninputvalidate4attachment' :
                                            (uploadImage && (uploadImage?.length === 5)) ? 'sectioninputvalidate5attachment' :
                                            (uploadImage && (uploadImage?.length === 6)) ? 'sectioninputvalidate6attachment' :
                                            (uploadImage && (uploadImage?.length === 7)) ? 'sectioninputvalidate7attachment' : 
                                            (uploadImage && (uploadImage?.length === 8)) ? 'sectioninputvalidate8attachment' : 
                                            (uploadImage && (uploadImage?.length === 9)) ? 'sectioninputvalidate9attachment' : 
                                            (uploadImage && (uploadImage?.length === 10)) ? 'sectioninputvalidate10attachment' : 
                                            'sectioninputvalidateattachment'
                                        }>
                                        <AttachmentUploader getImageUrl={getImageUrl} uploadImage={uploadImage} originalImageName={originalImageName} pastAttachment={validateAttachment}/>
                                        </div>
                                        <div className='sectionAbetween'></div> 
                                        <div className='form-control grievancePIC-form'>
                                            <input
                                                className='grievanceradio'
                                                type='radio'
                                                name='radiooption'
                                                value={4}
                                                onClick={(e) => setStatus(e.target.value)}
                                            />
                                            <label className='radiodesc'>Reject</label>
                                            <input
                                                className='grievanceradio'
                                                type='radio'
                                                name='radiooption'
                                                value={3}
                                                onClick={(e) => setStatus(e.target.value)}
                                            />
                                            <label className='radiodesc'>Close</label>
                                        </div>
                                        <div className='sectionA'></div>
                                        <Button style={{ float:"right" }} as='input' type='submit' value='Submit' />
                                        <Button style={{ float:"right" }} as='input' type='button' value='Save' onClick={saveValidate}/>
                                    </div>
                                </div>
                            </form>
                        </div>)}
                        
                        


                        {/* adminlogic */}
                        {( isAdmin && grievanceStatus == 1 && <div>
                            <form onSubmit={onSubmitAdmin}>
                                <div className='row readgrievance'>
                                    <div className='col-sm-3'>
                                        <div className='sectionA'>Priority: </div>
                                        <div className='sectionA'>Updated By: </div>
                                        <div className='sectionA'>Date: </div>
                                    </div>
                                    <div className='col-sm-3'>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={priority} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextname' value={currentUser} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={todayDate} readOnly /></div>
                                    </div>
                                    <div className='col-sm-6'></div>
                                    <div className='col-sm-3'>
                                        <div className='sectionARemarks'>Action Taken (Please take note that this message will be displayed on user's Audit Trail on mobile): </div>
                                    </div>
                                    <div className='col-sm-9'>
                                        <div className='sectionAinputRemarks'>
                                            <div className='form-control grievancePIC-form'>
                                                <textarea rows="6" cols="21"
                                                    placeholder='Insert action taken here...'
                                                    style={{ width: '99%', resize: "none" }}
                                                    defaultValue={actionRemark}
                                                    onChange={(e) => setAction(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-sm-3'>
                                        <div className={
                                            (uploadImage && (uploadImage?.length === 6)) ? 'sectionA6attachment' :
                                            (uploadImage && (uploadImage?.length === 7)) ? 'sectionA7attachment' : 
                                            (uploadImage && (uploadImage?.length === 8)) ? 'sectionA8attachment' : 
                                            (uploadImage && (uploadImage?.length === 9)) ? 'sectionA9attachment' : 
                                            (uploadImage && (uploadImage?.length === 10)) ? 'sectionA10attachment' : 
                                            'sectionAattachment'
                                        }>
                                            Upload Image (Please take note that the uploaded images will be displayed on user's Audit Trail on mobile): 
                                        </div>
                                    </div>
                                    <div className='col-sm-3'>
                                        <div className={
                                            (uploadImage && (uploadImage?.length === 6)) ? 'sectionAinput6attachment' :
                                            (uploadImage && (uploadImage?.length === 7)) ? 'sectionAinput7attachment' : 
                                            (uploadImage && (uploadImage?.length === 8)) ? 'sectionAinput8attachment' : 
                                            (uploadImage && (uploadImage?.length === 9)) ? 'sectionAinput9attachment' : 
                                            (uploadImage && (uploadImage?.length === 10)) ? 'sectionAinput10attachment' : 
                                            'sectionAinputattachment'
                                        }>
                                            <AttachmentUploader getImageUrl={getImageUrl} uploadImage={uploadImage} originalImageName={originalImageName} />
                                        </div> 
                                    </div>
                                    <div className='col-sm-6' style={{ position: 'relative' }}>
                                        <Button className="grievancesave" as='input' type='button' value='Save' onClick={saveAction}/>
                                        <Button className="grievancesubmit" as='input' type='submit' value='Submit' />
                                    </div>
                                </div>
                            </form>
                        </div>)}
                        {( isAdmin && grievanceStatus == 2 && <div>
                            <form onSubmit={onSubmitAdmin}>
                                <div className='row readgrievance'>
                                    <div className='col-sm-2'>
                                        <div className='sectionA'>Priority: </div>
                                        <div className='sectionA'>Updated By: </div>
                                        <div className='sectionA'>Date: </div>
                                        <div className='sectionARemarks'>Action Taken (Please take note that this message will be displayed on user's Audit Trail on mobile): </div>
                                        <div className='sectionAuditAttachmentCloseValidationVer' style={{ display: actionAttachment ? "block" : "none", paddingTop: '2px' }}>Attachments (Please take note that the uploaded images will be displayed on user's Audit Trail on mobile): </div>     
                                    </div>
                                    <div className='col-sm-4'>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={priority} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextname' value={updatename} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' value={updateTime} readOnly /></div>
                                        <div className='sectionAinputRemarks'><textarea style={{ resize: "none" }} rows="6" cols="21" className='formtextcolor' defaultValue={actionRemark} readOnly/></div>
                                        <div className='sectionAuditinputAttachmentCloseValidationVer' style={{ display: actionAttachment ? "block" : "none" }}>
                                            <img 
                                                src={DownloadIcon} 
                                                className='table-icon'
                                                style={{maxWidth: '50px'}} 
                                                onClick={() => {downloadactionAttachment()}} 
                                                alt=''
                                            />
                                        </div>  
                                    </div>
                                    <div className='col-sm-2'>
                                        <div className='sectionA'>Validated By: </div>
                                        <div className='sectionA'>Validated Date: </div>
                                        <div className='sectionARemarks'>Remark: </div>
                                        <div className={
                                            (uploadImage && (uploadImage?.length === 4)) ? 'sectionvalidate4attachment' :
                                            (uploadImage && (uploadImage?.length === 5)) ? 'sectionvalidate5attachment' :
                                            (uploadImage && (uploadImage?.length === 6)) ? 'sectionvalidate6attachment' :
                                            (uploadImage && (uploadImage?.length === 7)) ? 'sectionvalidate7attachment' : 
                                            (uploadImage && (uploadImage?.length === 8)) ? 'sectionvalidate8attachment' : 
                                            (uploadImage && (uploadImage?.length === 9)) ? 'sectionvalidate9attachment' : 
                                            (uploadImage && (uploadImage?.length === 10)) ? 'sectionvalidate10attachment' : 
                                            'sectionvalidateattachment'
                                        }>
                                            Upload Image: 
                                        </div>
                                        <div className='sectionAbetween'></div> 
                                        <div className='sectionA' style={{paddingTop:"9px"}}>Status: </div>    
                                    </div>
                                    <div className='col-sm-4'>
                                        <div className='sectionAinput'><input type="text" className='formtextname' value={currentUser} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={todayDate} readOnly/></div>
                                        <div className='sectionAinputRemarks'>
                                            <div className='form-control grievancePIC-form'>
                                                <textarea rows="6" cols="21"
                                                    placeholder='Please insert remarks here...'
                                                    style={{ width: '101.5%', resize: "none" }}
                                                    defaultValue={""}
                                                    onChange={(e) => setValidate(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className={
                                            (uploadImage && (uploadImage?.length === 4)) ? 'sectioninputvalidate4attachment' :
                                            (uploadImage && (uploadImage?.length === 5)) ? 'sectioninputvalidate5attachment' :
                                            (uploadImage && (uploadImage?.length === 6)) ? 'sectioninputvalidate6attachment' :
                                            (uploadImage && (uploadImage?.length === 7)) ? 'sectioninputvalidate7attachment' : 
                                            (uploadImage && (uploadImage?.length === 8)) ? 'sectioninputvalidate8attachment' : 
                                            (uploadImage && (uploadImage?.length === 9)) ? 'sectioninputvalidate9attachment' : 
                                            (uploadImage && (uploadImage?.length === 10)) ? 'sectioninputvalidate10attachment' : 
                                            'sectioninputvalidateattachment'
                                        }>
                                        <AttachmentUploader getImageUrl={getImageUrl} uploadImage={uploadImage} originalImageName={originalImageName} />
                                        </div>
                                        <div className='sectionAbetween'></div> 
                                        <div className='form-control grievancePIC-form'>
                                            <input
                                                className='grievanceradio'
                                                type='radio'
                                                name='radiooption'
                                                value={4}
                                                onClick={(e) => setStatus(e.target.value)}
                                            />
                                            <label className='radiodesc'>Reject</label>
                                            <input
                                                className='grievanceradio'
                                                type='radio'
                                                name='radiooption'
                                                value={3}
                                                onClick={(e) => setStatus(e.target.value)}
                                            />
                                            <label className='radiodesc'>Close</label>
                                        </div>
                                        <div className='sectionA'></div>
                                        <Button style={{ float:"right", marginLeft:"20px" }} as='input' type='submit' value='Submit' />
                                        <Button style={{ float:"right" }} as='input' type='button' value='Save' onClick={saveValidate}/>
                                    </div>
                                </div>
                            </form>
                        </div>)}
                        {( isAdmin && grievanceStatus == 3 && <div>
                            <div style={{ display: updateID === closeID ? "block" : "none" }}>
                                <div className='row readgrievance'>
                                    <div className='col-sm-3'>
                                        <div className='sectionA'>Priority: </div>
                                        <div className='sectionA'>Updated By: </div>
                                        <div className='sectionA'>Date: </div>      
                                    </div>
                                    <div className='col-sm-3'>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={priority} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextname' value={closename} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' value={closedTime} readOnly /></div>   
                                    </div>
                                    <div className='col-sm-3'></div>
                                    <div className='col-sm-3'></div>
                                    <div className='col-sm-3'>
                                        <div className='sectionARemarks'>Action Taken (Please take note that this message will be displayed on user's Audit Trail on mobile): </div>
                                    </div>
                                    <div className='col-sm-9'>
                                        <div className='sectionAinputRemarks'><textarea style={{ resize: "none" }} rows="6" cols="21" className='formtextcolor' defaultValue={actionRemark} readOnly/></div>
                                    </div>
                                    <div className='col-sm-3'>
                                        <div className='sectionAuditAttachmentCloseValidationVer' style={{ display: actionAttachment ? "block" : "none", paddingTop: '2px' }}>Attachments (Please take note that the uploaded images will be displayed on user's Audit Trail on mobile): </div>
                                        <div className='sectionA'>Status: </div>
                                    </div>
                                    <div className='col-sm-3'>
                                        <div className='sectionAuditinputAttachmentCloseValidationVer' style={{ display: actionAttachment ? "block" : "none" }}>
                                            <img 
                                                src={DownloadIcon} 
                                                className='table-icon'
                                                style={{maxWidth: '50px'}} 
                                                onClick={() => {downloadactionAttachment()}} 
                                                alt=''
                                            />
                                        </div>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={currentStatusName} readOnly/></div>
                                    </div>
                                </div>
                            </div>
                            <div style={{ display: updateID !== closeID ? "block" : "none" }}>
                                <div className='row readgrievance'>
                                    <div className='col-sm-2'>
                                        <div className='sectionA'>Priority: </div>
                                        <div className='sectionA'>Updated By: </div>
                                        <div className='sectionA'>Date: </div>
                                        <div className='sectionARemarks'>Action Taken (Please take note that this message will be displayed on user's Audit Trail on mobile): </div>
                                        <div className='sectionAuditAttachmentCloseValidationVer' style={{ display: actionAttachment ? "block" : "none", paddingTop: '2px' }}>Attachments (Please take note that the uploaded images will be displayed on user's Audit Trail on mobile): </div>
                                    </div>
                                    <div className='col-sm-4'>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={priority} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextname' value={updatename} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' value={updateTime} readOnly /></div>
                                        <div className='sectionAinputRemarks'><textarea style={{ resize: "none" }} rows="6" cols="21" className='formtextcolor' defaultValue={actionRemark} readOnly/></div>
                                        <div className='sectionAuditinputAttachmentCloseValidationVer' style={{ display: actionAttachment ? "block" : "none" }}>
                                            <img 
                                                src={DownloadIcon} 
                                                className='table-icon'
                                                style={{maxWidth: '50px'}} 
                                                onClick={() => {downloadactionAttachment()}} 
                                                alt=''
                                            />
                                        </div>
                                    </div>
                                    <div className='col-sm-2'>
                                        <div className='sectionA'>Validated By: </div>
                                        <div className='sectionA'>Validated Date: </div>
                                        <div className='sectionA'>Status: </div>
                                        <div className='sectionARemarks'>Remarks: </div>
                                        <div className='sectionAuditAttachment' style={{ display: validateAttachment ? "block" : "none", paddingTop: '10px' }}>Attachments: </div>                                        
                                    </div>
                                    <div className='col-sm-4'>
                                        <div className='sectionAinput'><input type="text" className='formtextname' value={closename} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' value={closedTime} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={currentStatusName} readOnly/></div>
                                        <div className='sectionAinputRemarks'><textarea style={{ resize: "none" }} rows="6" cols="21" className='formtextcolor' defaultValue={closeRemark} readOnly /></div>
                                        <div className='sectionAuditinputattachment' style={{ display: validateAttachment ? "block" : "none" }}>
                                            <img 
                                                src={DownloadIcon} 
                                                className='table-icon'
                                                style={{maxWidth: '50px'}} 
                                                onClick={() => {downloadvalidateAttachment()}} 
                                                alt=''
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>)}
                        {( isAdmin && grievanceStatus == 4 && <div>
                            <form onSubmit={onSubmitAdmin}>
                                <div className='row readgrievance'>
                                    <div className='col-sm-2'>
                                        <div className='sectionA'>Priority: </div>
                                        <div className='sectionA'>Updated By: </div>
                                        <div className='sectionA'>Date: </div>
                                    </div>
                                    <div className='col-sm-4'>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={priority} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextname' value={currentUser} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={todayDate} readOnly /></div> 
                                    </div>
                                    <div className='col-sm-6'></div>
                                    <div className='col-sm-2'>
                                        <div className='sectionARemarks'>Action Taken (Please take note that this message will be displayed on user's Audit Trail on mobile): </div>
                                    </div>
                                    <div className='col-sm-10'>
                                        <div className='sectionAinputRemarks'>
                                            <div className='form-control grievancePIC-form'>
                                                <textarea rows="6" cols="21"
                                                    placeholder='Insert action taken here...'
                                                    style={{ width: '100%', resize: "none" }}
                                                    defaultValue={""}
                                                    onChange={(e) => setAction(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-sm-2'>
                                        <div className={
                                            (uploadImage && (uploadImage?.length === 6)) ? 'sectionA6attachment' :
                                            (uploadImage && (uploadImage?.length === 7)) ? 'sectionA7attachment' : 
                                            (uploadImage && (uploadImage?.length === 8)) ? 'sectionA8attachment' : 
                                            (uploadImage && (uploadImage?.length === 9)) ? 'sectionA9attachment' : 
                                            (uploadImage && (uploadImage?.length === 10)) ? 'sectionA10attachment' : 
                                            'sectionAattachment'
                                        }>
                                            Upload Image (Please take note that the uploaded images will be displayed on user's Audit Trail on mobile): 
                                        </div>
                                    </div>
                                    <div className='col-sm-4'>
                                        <div className={
                                            (uploadImage && (uploadImage?.length === 6)) ? 'sectionAinput6attachment' :
                                            (uploadImage && (uploadImage?.length === 7)) ? 'sectionAinput7attachment' : 
                                            (uploadImage && (uploadImage?.length === 8)) ? 'sectionAinput8attachment' : 
                                            (uploadImage && (uploadImage?.length === 9)) ? 'sectionAinput9attachment' : 
                                            (uploadImage && (uploadImage?.length === 10)) ? 'sectionAinput10attachment' : 
                                            'sectionAinputattachment'
                                        }>
                                            <AttachmentUploader getImageUrl={getImageUrl} uploadImage={uploadImage} originalImageName={originalImageName} />
                                        </div>
                                    </div>
                                    <div className='col-sm-6' style={{ position: 'relative' }}>
                                        <Button className="grievancesave" as='input' type='button' value='Save' onClick={saveAction}/>
                                        <Button className="grievancesubmit" as='input' type='submit' value='Submit' />
                                    </div>
                                </div>
                            </form>
                        </div>)}
                        {( isAdmin && grievanceStatus == 5 &&<div>
                            <form onSubmit={onSubmitAdmin}>
                                <div className='row readgrievance'>
                                    <div className='col-sm-3'>
                                        <div className='sectionA'>Priority: </div>
                                        <div className='sectionA'>Updated By: </div>
                                        <div className='sectionA'>Date: </div>
                                    </div>
                                    <div className='col-sm-3'>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={priority} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextname' value={currentUser} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={todayDate} readOnly /></div>
                                    </div>
                                    <div className='col-sm-6'></div>
                                    <div className='col-sm-3'>
                                        <div className='sectionARemarks'>Action Taken (Please take note that this message will be displayed on user's Audit Trail on mobile): </div>
                                    </div>
                                    <div className='col-sm-9'>
                                        <div className='sectionAinputRemarks'>
                                            <div className='form-control grievancePIC-form'>
                                                <textarea rows="6" cols="21"
                                                    placeholder='Insert action taken here...'
                                                    style={{ width: '99%', resize: "none" }}
                                                    defaultValue={actionRemark}
                                                    onChange={(e) => setAction(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-sm-3'>
                                        <div className='sectionAuditAttachment' style={{ display: actionAttachment ? "block" : "none", paddingTop: '10px' }}>Attachment Log: </div>
                                        <div className={
                                            (uploadImage && (uploadImage?.length === 6)) ? 'sectionA6attachment' :
                                            (uploadImage && (uploadImage?.length === 7)) ? 'sectionA7attachment' : 
                                            (uploadImage && (uploadImage?.length === 8)) ? 'sectionA8attachment' : 
                                            (uploadImage && (uploadImage?.length === 9)) ? 'sectionA9attachment' : 
                                            (uploadImage && (uploadImage?.length === 10)) ? 'sectionA10attachment' : 
                                            'sectionAattachment'
                                        }>
                                            Upload Image (Please take note that the uploaded images will be displayed on user's Audit Trail on mobile): 
                                        </div>
                                    </div>
                                    <div className='col-sm-3'>
                                        <div className='sectionAuditinputattachment' style={{ display: actionAttachment ? "block" : "none" }}>
                                            <img 
                                                src={DownloadIcon} 
                                                className='table-icon'
                                                style={{maxWidth: '50px'}} 
                                                onClick={() => {downloadactionAttachment()}} 
                                                alt=''
                                            />
                                        </div>
                                        <div className={
                                            (uploadImage && (uploadImage?.length === 6)) ? 'sectionAinput6attachment' :
                                            (uploadImage && (uploadImage?.length === 7)) ? 'sectionAinput7attachment' : 
                                            (uploadImage && (uploadImage?.length === 8)) ? 'sectionAinput8attachment' : 
                                            (uploadImage && (uploadImage?.length === 9)) ? 'sectionAinput9attachment' : 
                                            (uploadImage && (uploadImage?.length === 10)) ? 'sectionAinput10attachment' : 
                                            'sectionAinputattachment'
                                        }>
                                            <AttachmentUploader getImageUrl={getImageUrl} uploadImage={uploadImage} originalImageName={originalImageName} pastAttachment={actionAttachment} />
                                        </div> 
                                    </div>
                                    <div className='col-sm-6' style={{ position: 'relative' }}>
                                        <Button className="grievancesave" as='input' type='button' value='Save' onClick={saveAction}/>
                                        <Button className="grievancesubmit" as='input' type='submit' value='Submit' />
                                    </div>
                                </div>
                            </form>
                        </div>)}
                        {( isAdmin && grievanceStatus == 6 &&<div>
                            <form onSubmit={onSubmitAdmin}>
                                <div className='row readgrievance'>
                                    <div className='col-sm-2'>
                                        <div className='sectionA'>Priority: </div>
                                        <div className='sectionA'>Updated By: </div>
                                        <div className='sectionA'>Date: </div>
                                        <div className='sectionARemarks'>Action Taken (Please take note that this message will be displayed on user's Audit Trail on mobile): </div>
                                        <div className='sectionAuditAttachmentCloseValidationVer' style={{ display: actionAttachment ? "block" : "none", paddingTop: '10px' }}>Attachments (Please take note that the uploaded images will be displayed on user's Audit Trail on mobile): </div>     
                                    </div>
                                    <div className='col-sm-4'>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={priority} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextname' value={updatename} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' value={updateTime} readOnly /></div>
                                        <div className='sectionAinputRemarks'><textarea style={{ resize: "none" }} rows="6" cols="21" className='formtextcolor' defaultValue={actionRemark} readOnly/></div>
                                        <div className='sectionAuditinputAttachmentCloseValidationVer' style={{ display: actionAttachment ? "block" : "none" }}>
                                            <img 
                                                src={DownloadIcon} 
                                                className='table-icon'
                                                style={{maxWidth: '50px'}} 
                                                onClick={() => {downloadactionAttachment()}} 
                                                alt=''
                                            />
                                        </div>  
                                    </div>
                                    <div className='col-sm-2'>
                                        <div className='sectionA'>Validated By: </div>
                                        <div className='sectionA'>Validated Date: </div>
                                        <div className='sectionARemarks'>Remark: </div>
                                        <div className='sectionAuditAttachment' style={{ display: validateAttachment ? "block" : "none", paddingTop: '10px' }}>Attachment Log: </div> 
                                        <div className={
                                            (uploadImage && (uploadImage?.length === 4)) ? 'sectionvalidate4attachment' :
                                            (uploadImage && (uploadImage?.length === 5)) ? 'sectionvalidate5attachment' :
                                            (uploadImage && (uploadImage?.length === 6)) ? 'sectionvalidate6attachment' :
                                            (uploadImage && (uploadImage?.length === 7)) ? 'sectionvalidate7attachment' : 
                                            (uploadImage && (uploadImage?.length === 8)) ? 'sectionvalidate8attachment' : 
                                            (uploadImage && (uploadImage?.length === 9)) ? 'sectionvalidate9attachment' : 
                                            (uploadImage && (uploadImage?.length === 10)) ? 'sectionvalidate10attachment' : 
                                            'sectionvalidateattachment'
                                        }>
                                            Upload Image: 
                                        </div>
                                        <div className='sectionAbetween'></div> 
                                        <div className='sectionA' style={{paddingTop:"9px"}}>Status: </div>    
                                    </div>
                                    <div className='col-sm-4'>
                                        <div className='sectionAinput'><input type="text" className='formtextname' value={currentUser} readOnly/></div>
                                        <div className='sectionAinput'><input type="text" className='formtextcolor' defaultValue={todayDate} readOnly/></div>
                                        <div className='sectionAinputRemarks'>
                                            <div className='form-control grievancePIC-form'>
                                                <textarea rows="6" cols="21"
                                                    placeholder='Please insert remarks here...'
                                                    style={{ width: '101.5%', resize: "none" }}
                                                    defaultValue={validateRemark}
                                                    onChange={(e) => setValidate(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className='sectionAuditinputattachment' style={{ display: validateAttachment ? "block" : "none" }}>
                                            <img 
                                                src={DownloadIcon} 
                                                className='table-icon'
                                                style={{maxWidth: '50px'}} 
                                                onClick={() => {downloadvalidateAttachment()}} 
                                                alt=''
                                            />
                                        </div>
                                        <div className={
                                            (uploadImage && (uploadImage?.length === 4)) ? 'sectioninputvalidate4attachment' :
                                            (uploadImage && (uploadImage?.length === 5)) ? 'sectioninputvalidate5attachment' :
                                            (uploadImage && (uploadImage?.length === 6)) ? 'sectioninputvalidate6attachment' :
                                            (uploadImage && (uploadImage?.length === 7)) ? 'sectioninputvalidate7attachment' : 
                                            (uploadImage && (uploadImage?.length === 8)) ? 'sectioninputvalidate8attachment' : 
                                            (uploadImage && (uploadImage?.length === 9)) ? 'sectioninputvalidate9attachment' : 
                                            (uploadImage && (uploadImage?.length === 10)) ? 'sectioninputvalidate10attachment' : 
                                            'sectioninputvalidateattachment'
                                        }>
                                        <AttachmentUploader getImageUrl={getImageUrl} uploadImage={uploadImage} originalImageName={originalImageName} pastAttachment={validateAttachment}/>
                                        </div>
                                        <div className='sectionAbetween'></div> 
                                        <div className='form-control grievancePIC-form'>
                                            <input
                                                className='grievanceradio'
                                                type='radio'
                                                name='radiooption'
                                                value={4}
                                                onClick={(e) => setStatus(e.target.value)}
                                            />
                                            <label className='radiodesc'>Reject</label>
                                            <input
                                                className='grievanceradio'
                                                type='radio'
                                                name='radiooption'
                                                value={3}
                                                onClick={(e) => setStatus(e.target.value)}
                                            />
                                            <label className='radiodesc'>Close</label>
                                        </div>
                                        <div className='sectionA'></div>
                                        <Button style={{ float:"right", marginLeft:"20px" }} as='input' type='submit' value='Submit' />
                                        <Button style={{ float:"right" }} as='input' type='button' value='Save' onClick={saveValidate}/>
                                    </div>
                                </div>
                            </form>
                        </div>)}
                        

                    </div>
                    <br></br>
                </div>
            )}
        </Fragment>
    );
};

export default GrievanceForm;